import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form, Badge, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Alert
} from "reactstrap";

import FilesCustom from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';
import WidgetBreadcrumb from 'components/WidgetBreadcrumb';
import PdfViewer from 'components/PdfViewer';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import AGenerateModel from 'components/generic/AGenerateModel';

import { withRouter } from 'components/withRouter';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Editor } from 'components/TinyMCE-react';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

class ManageLeads extends Component {
    static displayName = ManageLeads.name;

    static leadModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    static filesType;

    modalGenManager = React.createRef();

    constructor(props) {
        super(props);

        this.leadGen = React.createRef(null);

        var defLeadCategoryGroupKey = "";
        var defLeadPageModels = "";
        if (props.searchParams) {
            defLeadCategoryGroupKey = props.searchParams.get("categoryGroupKey") || "";
            defLeadPageModels = props.searchParams.get("pageModels") || "";
        }

        this.state = {
            leads: [], curLead: null, curLeadId: 0, status: [], defaultStatus: 3001, curStatus: 3001/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1",
            title: props.i18nManager.t("lead.noSelected"), editionMode: false, categoryGroupKey: defLeadCategoryGroupKey, pageModels: defLeadPageModels, onlyActives: true, altMode: false
        };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            //commonFunc.getMethod("../api/lead/GetLeadModels", { id: -1 }).then((responseModels) => {
            commonFunc.getMethod("../api/data/GetAllModels", { filter: "lead"/*, categ: context.state.categ*/, useParentSite: true, excludeMode: 1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.leadModels = {};
                    //dataModels.result.models.forEach((model) => {
                    dataModels.result.map(model => model.tag).forEach((model) => {
                        var modelObj = JSON.parse(model.value);
                        if (!modelObj.objType) {//Array.isArray(modelObj)
                            var useSub = false;
                            Object.keys(modelObj).forEach(key => {
                                var subModel = modelObj[key];
                                if (subModel.objType) {
                                    useSub = true;
                                    context.leadModels[key] = subModel;
                                }
                            });
                            if (!useSub) context.leadModels[model.extID] = modelObj;
                        }
                        else context.leadModels[model.extID] = modelObj;
                    });

                    var configStatus = context.state.curStatus;
                    var altMode = false;
                    if (context.leadModels["LEAD_CONFIGS"]) {
                        var configPage = context.leadModels["LEAD_CONFIGS"][context.state.pageModels];
                        configStatus = (configPage?.srcObject?.defaultStatus || configStatus);
                        altMode = configPage?.srcObject?.altMode;
                        context.setState({ curStatus: configStatus, altMode: altMode });
                    }



                    //context.leadModels["CONTACTS"] = {};
                    //context.leadModels["DT_CTCS"] = {};
                    //context.leadModels["DLG_CONTACT"] = {};
                    

                    var initPage = () => {
                        //Chargement via url
                        var defLeadLoadId = 0;
                        var defLeadActionId = 0;
                        if (context.props.searchParams) {
                            defLeadLoadId = parseInt(context.props.searchParams.get("leadId")) || 0;
                            defLeadActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                        }
                        if (defLeadLoadId > 0) {
                            var defLeadStatusId = parseInt(context.props.searchParams.get("statusId")) || configStatus;

                            context.loadStatusBtnGrp(defLeadStatusId);

                            context.getLeads(defLeadStatusId, false, function () {
                                if (altMode) {
                                    var element = document.querySelector('.card-' + defLeadLoadId);
                                    if (element) {
                                        const elementBottom = element.offsetTop - 68;//marginTop - mainPanel/content
                                        context.props.getScroller().smoothScroll(elementBottom);
                                        context.refreshCb = null;
                                    }
                                }
                                else {
                                    if (context) {
                                        context.loadReportCb = () => {
                                            if (defLeadActionId) context.switchTab(defLeadActionId.toString());

                                            //setTimeout(function () {
                                            var element = document.querySelector('.tableContainer');
                                            const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                            context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                            //}, 2000);
                                        };
                                    }
                                    showDtSelID("tableLeads", defLeadLoadId);
                                }
                            });
                        } else {
                            context.loadStatusBtnGrp(configStatus);

                            context.getLeads();

                            if (defLeadActionId) context.switchTab(defLeadActionId.toString());

                            /*if (defLeadActionId == 1) {
                                $(".action-addReport:visible").click();
                            }*/
                        }
                    };

                    context.filesType = null;
                    if (altMode) {
                        commonFunc.getMethod("../api/lead/GetLeadFilesType", null).then((response) => {
                            if (response.data && response.data.isSuccess) {
                                context.filesType = response.data.result.filter(type => type.refExtID !== "AVA");
                                initPage();
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec de chargement des Types de Fichier :<br>" + response.data.errorMessage
                                });
                                initPage();
                            }
                        });
                    }
                    else initPage();

                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (/*prevState.historicalReports !== this.state.historicalReports || */prevState.curStatus !== this.state.curStatus || prevState.categoryGroupKey !== this.state.categoryGroupKey || prevState.pageModels !== this.state.pageModels) {
            this.getLeads();
        }
        else {
            var defLeadCategoryGroupKey = "";
            var defLeadPageModels = "";
            if (this.props.searchParams) {
                defLeadCategoryGroupKey = this.props.searchParams.get("categoryGroupKey") || "";
                defLeadPageModels = this.props.searchParams.get("pageModels") || "";
            }

            if (this.state.categoryGroupKey !== defLeadCategoryGroupKey || this.state.pageModels !== defLeadPageModels) {
                this.setState({ categoryGroupKey: defLeadCategoryGroupKey, pageModels: defLeadPageModels });
            }
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateLead
        if (this.state.curLeadId === 0 /*&& prevState.curLeadId !== this.state.curLeadId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableLeads"]) this.dtFunctions["tableLeads"].setDisabled(this.state.editionMode);


        if (this.state.altMode && !this.state.switchDisplay) {
            if (this.refreshCb) {
                if (this.refreshCb && typeof (this.refreshCb) === "function") { this.refreshCb(); }
            }
        }
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        //TEMP : doit dépendre d'une configuration (tout virer sauf createdCell et cbInitComplete)
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadLead(rowData.idLead, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idLead;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadLead(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadLead();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
        var pageConfig = {
            "objType": "model", "templates": [
                { "title": "i18n:lead.tabDetails", "objType": "template", "subType": "LEAD", "checkRights": { "entity": "LEAD", "rights": "R" } },
                { "title": "i18n:lead.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "LEAD_CONTACTS", "rights": "L" } },
                { "title": "i18n:lead.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "LEAD_FILES", "rights": "L" } },
                { "title": "i18n:lead.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "LEAD_FLOWS", "rights": "L" } },
                { "title": "i18n:lead.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "LEAD", "rights": "C" } }
            ]
        };
        if (context.leadModels && context.leadModels["LEAD_CONFIGS"]) {
            pageConfig = context.leadModels["LEAD_CONFIGS"][context.state.pageModels] || pageConfig;
        }

        

        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();
            var targetRoles = curUser.roles ? curUser.roles[0] : null;
            var leadModel;
            var srcModel;
            var resFilter = Object.keys(this.leadModels).filter((key) => {
                var model = this.leadModels[key];
                if (key === "LEAD" || key === ("LEAD_" + this.state.curLead?.categoryID)) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "LEAD_" + targetRoles || (key === ("LEAD_" + this.state.curLead?.categoryID + "_") + targetRoles);
            });
            if (resFilter && resFilter.length) {
                leadModel = this.leadModels[resFilter[0]];
            }
            else if (srcModel) {
                leadModel = srcModel;
            }
            else {
                leadModel = this.leadModels ? (this.leadModels["LEAD_" + this.state.curLead?.categoryID] || this.leadModels["LEAD"]) : {};
            }

            var filesAltObj = {};
            if (context.filesType) filesAltObj.filesType = context.filesType;
            else filesAltObj.altFilesTypes = "../api/lead/GetLeadFilesType";

            //Gestion onglet Documents
            if (this.state.altMode && context.state.curLead?.leadFiles?.length) {
                filesAltObj.files = context.state.curLead?.leadFiles.map(tf => tf.file);
                //filesAltObj.noRemove = true; //TODO : Voir si on verrouille dans tout les cas ou on laisse la main qu'aux sites concernés
                filesAltObj.setFiles = (cptFiles) => { context.loadLead(context.state.curLeadId); };
            }


            var saveCb = () => {
                //context.loadLead(leadResponse.result.idLead);
                context.getLeads(3000, true, () => {
                    //showDtSelID("tableLeads", data.result.idLead);
                });
            };
            

            var cptSysCollection = {
                "LEAD": <ShowDetails id={this.state.curLeadId} type="lead" genRef={this.leadGen} data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={leadModel} modelsList={this.leadModels}
                    loadElem={this.loadLead.bind(this)} saveElem={this.contextSaveLead.bind(this)} removeElem={this.removeLead.bind(this)} updateStatusElem={this.updateLeadStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()}
                    dialogShowLead={() => { dialogAltLead(context.props.i18nManager.t("lead.tabDetails"), "DLG_LEAD", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                    dialogEditLead={() => { showDialogLead(altT(templatesWidgetList[0].name), templatesWidgetList[0].tag, this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                    dialogDuplicateLead={() => { showDialogLead(altT(templatesWidgetList[0].name.replace("edit", "duplicate")), templatesWidgetList[0].tag, this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager, true); }}
                    manageEmail={() => { sendEmailDialog(this.state.curLead, context.props.dataCfg, context.props.i18nManager); }}
                    dialogLossLead={() => { dialogAltLead(context.props.i18nManager.t("lead.leadloss"), "LEADLOSS", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager); }}
                    dialogScheduleVisit={() => { dialogAltLead(context.props.i18nManager.t("lead.scheduleVisit"), "SCHEDULEVISIT", this.state.curLead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}
                    manageShopOrder={() => { context.manageShopOrder(this.state.curLead, context) }}
                    generateLeadRecap={() => { context.generateLeadRecap(this.state.curLead) }} />,
                "CONTACTS": <ShowDetails id={this.state.curLeadId} type="leadContacts" data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.leadModels ? this.leadModels["CONTACTS"] : {}} modelsList={this.leadModels} shouldRender={this.state.activeTab === index.toString()} />,
                "CONTACTS_MSITES": <ShowDetails id={this.state.curLeadId} type="leadContacts" data={this.state.curLead} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.leadModels ? this.leadModels["CONTACTS_MSITES"] : {}} modelsList={this.leadModels}
                    loadElem={this.loadLead.bind(this)} shouldRender={this.state.activeTab === index.toString()} />,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="lead-files" bindID={this.state.curLeadId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="LEAD" src={this.state.curLead} waitForCompletion={(fileUpReq) => { return fileUpReq.ftype === "DVS"; }}
                        srcName={this.state.curLead ? this.state.curLead.title : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"DVS"} {...filesAltObj}
                        altFilesUrl="../api/lead/GetLeadFiles" altRemoveFilesUrl="../api/lead/RemoveLeadFile" altUploadFilesUrl="../api/lead/UploadLeadFiles" />
                </Form>,//noRemove={/*this.state.altMode ? "PDF" :*/ false}
                "FLOWS": <Row className="lead-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("lead.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="lead" elemId={context.state.curLeadId} rows={context.state.curLead?.flows} url="../api/lead/GetLeadFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };


        var validLeads = this.state.leads.filter(lead => {
            return !(lead.idLead <= 0);
        });
        var filteredLeads = validLeads.filter(lead => {
            if (context.state.onlyActives && lead.status?.step === 5) return false;
            if (context.state.assignSiteFilter > 0 && lead.assignSiteID !== context.state.assignSiteFilter) return false;
            if (context.state.serviceFilter > 0 && lead.serviceID !== context.state.serviceFilter) return false;

            var searchProc = (field, searchField) => {
                var editField = field.trim().replaceAll(" ", "").toLowerCase();
                editField = editField
                    .replace(/έ/g, 'ε')
                    .replace(/[ύϋΰ]/g, 'υ')
                    .replace(/ώ/g, 'ω')
                    .replace(/ά/g, 'α')
                    .replace(/[ίϊΐ]/g, 'ι')
                    .replace(/ή/g, 'η')
                    .replace(/\n/g, ' ')
                    .replace(/á/g, 'a')
                    .replace(/â/g, 'a')
                    .replace(/ã/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/ê/g, 'e')
                    .replace(/ë/g, 'e')
                    .replace(/è/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/î/g, 'i')
                    .replace(/ï/g, 'i')
                    .replace(/ì/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ô/g, 'o')
                    .replace(/õ/g, 'o')
                    .replace(/ό/g, 'ο')
                    .replace(/ú/g, 'u')
                    .replace(/ü/g, 'u')
                    .replace(/ç/g, 'c');
                var editSearchField = searchField || (context.state.searchField?.trim()/*.replaceAll(" ", "")*/.toLowerCase()
                    .replace(/έ/g, 'ε')
                    .replace(/[ύϋΰ]/g, 'υ')
                    .replace(/ώ/g, 'ω')
                    .replace(/ά/g, 'α')
                    .replace(/[ίϊΐ]/g, 'ι')
                    .replace(/ή/g, 'η')
                    .replace(/\n/g, ' ')
                    .replace(/á/g, 'a')
                    .replace(/â/g, 'a')
                    .replace(/ã/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/ê/g, 'e')
                    .replace(/ë/g, 'e')
                    .replace(/è/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/î/g, 'i')
                    .replace(/ï/g, 'i')
                    .replace(/ì/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ô/g, 'o')
                    .replace(/õ/g, 'o')
                    .replace(/ό/g, 'ο')
                    .replace(/ú/g, 'u')
                    .replace(/ü/g, 'u')
                    .replace(/ç/g, 'c'));

                var splitField = editSearchField?.split(" ");
                if (splitField?.length > 1) {
                    var flag = true;
                    splitField.forEach(subField => {
                        flag &= searchProc(field, subField);
                    });
                    return flag;
                }
                else return editField.indexOf(editSearchField) >= 0;

                //return editField.indexOf(editSearchField) >= 0;
            };

            if (context.state.searchField && !(searchProc(lead.title) || searchProc(lead.client?.name) || searchProc(lead.client?.firstName) || searchProc(lead.client?.name + " " + lead.client?.firstName) || searchProc(lead.tel) || searchProc(lead.status?.name))) return false;
            return true;
        }).sort((a, b) => {
            if (a.priority !== b.priority) {
                return b.priority - a.priority;
            }
            /*else if (a.priority && b.priority) {
                return moment(a.dSysMod).diff(b.dSysMod, "seconds");
            }*/
            return moment(b.dSysMod).diff(a.dSysMod, "seconds");
        });


        var templatesWidgetList = pageConfig?.templates?.filter(template => template.objType === "widgetList");
        if (!context.state.switchDisplay && templatesWidgetList.length > 0) {
            try {
                if (context.state.pageModels === "PROJECTLEAD") {
                    return this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                        <div className="widgetListDetails">
                            <Button className=" btn-icon btn-round mt-0" color="primary" onClick={() => {
                                context.setState({ switchDisplay: !context.state.switchDisplay, serviceFilter: -1, searchField: "", onlyActives: false, dataStamp: new Date().getTime() });
                            }}><i className="fa fa-table"></i></Button>
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" onClick={() => this.getLeads()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {pageConfig?.templates?.map((template, index) => {
                                if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                    switch (template.subType) {
                                        case "ADD":
                                            return <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => this.initCreateLead()}>
                                                <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                            </Button>;
                                        case "DIALOGADD":
                                            var saveCb = (leadResponse) => {
                                                //context.loadLead(leadResponse.result.idLead);
                                                context.getLeads(3000, true, () => {
                                                    //showDtSelID("tableLeads", data.result.idLead);
                                                });
                                            };

                                            return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                <i className="fa fa-user-plus fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                            </Button>;
                                        default: return "";
                                    }
                                }
                                else return "";
                            })}
                            {<span className="ms-1">{`${filteredLeads.length} élément(s) ${(validLeads.length - filteredLeads.length) > 0 ? ("(filtré de " + validLeads.length + " éléments au total)") : ""}`}</span>}
                            <div className="float-end mb-1 mt-2">
                                <div className={`form-check form-check-inline fcheck-sm form-group float-sm-end m-0 ms-2 me-4 mt-1`}>
                                    <Label check for={"onlyactives"} className={`d-inline-block px-0 w-100`} style={{ minWidth: "16px" }}>
                                        <div className={`d-inline-block me-2 px-0`}>{context.props.i18nManager.t("lead.onlyactivesFilter")}</div>
                                        <div className={`d-inline-block`} style={{ position: "relative", top: "-12px" }}>
                                            <Input type="checkbox" id={"onlyactives"} checked={context.state.onlyActives} onChange={(e) => {
                                                context.setState({ onlyActives: e.target.checked });
                                            }} />
                                            <span className={`form-check-sign`} />
                                        </div>
                                    </Label>
                                </div>
                                <div className="float-sm-end">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectAssignSite"}>{context.props.i18nManager.t("lead.assignSiteFilter")}</Label>
                                    <Input id={"selectAssignSite"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                        var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                        var curFilter = selValue;
                                        context.setState({ assignSiteFilter: parseInt(curFilter) });
                                    }} value={context.state.assignSiteFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];

                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.extSite?.name;
                                                var value = row.assignSiteID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });

                                            //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(allOpt);

                                            return options.map((option, index) => {
                                                return <option className={`${option.hidden ? "d-none" : ""}`} key={index} value={option.value}>
                                                    {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                    {option.title}
                                                </option>
                                            });
                                        })()}
                                    </Input>
                                </div>
                                <div className="float-sm-end">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectService"}>{context.props.i18nManager.t("lead.serviceFilter")}</Label>
                                    <Input id={"selectService"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                        var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                        var curFilter = selValue;
                                        context.setState({ serviceFilter: parseInt(curFilter) });
                                    }} value={context.state.serviceFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];

                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.service?.name;
                                                var value = row.serviceID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });

                                            //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(allOpt);

                                            return options.map((option, index) => {
                                                return <option className={`${option.hidden ? "d-none" : ""}`} key={index} value={option.value}>
                                                    {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                    {option.title}
                                                </option>
                                            });
                                        })()}
                                    </Input>
                                </div>
                                <div className="float-sm-end">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"inputSearch"}>{context.props.i18nManager.t("lead.inputSearchFilter")}</Label>
                                    <Input id={"inputSearch"} bsSize="sm" className={`w-auto d-inline-block`} placeholder={context.props.i18nManager.t("lead.inputSearchHolder")} type="text" style={{ maxWidth: "200px" }} autoComplete="off" aria-autocomplete="none" onChange={(e) => {
                                        var curFilter = e.target.value;
                                        context.setState({ searchField: curFilter });
                                    }}>
                                    </Input>
                                </div>
                            </div>
                            <div style={{ clear: "both" }}></div>
                            {filteredLeads.map(lead => {
                                try {
                                    return <CardProject key={`project-${lead.idLead}`} lead={lead} context={context} altT={altT} templatesWidgetList={templatesWidgetList} />;
                                }
                                catch (e) {
                                    console.error(e);
                                    return <div className="badge badge-danger my-3">Une erreur est survenu lors du chargement de ce widget {"- " + lead.idLead + " " + lead.client?.name + " - " + lead.service?.name/*lead.title*/}</div>
                                }
                            })}
                        </div>;
                }
                else if (context.state.pageModels === "DIALOGLEAD") {
                    return this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                        <div className="widgetListDetails">
                            <Button className=" btn-icon btn-round mt-0" color="primary" onClick={() => {
                                context.setState({ switchDisplay: !context.state.switchDisplay, serviceFilter: -1, searchField: "", onlyActives: false, dataStamp: new Date().getTime() });
                            }}><i className="fa fa-table"></i></Button>
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" onClick={() => this.getLeads()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {pageConfig?.templates?.map((template, index) => {
                                if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                    switch (template.subType) {
                                        case "ADD":
                                            return <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => this.initCreateLead()}>
                                                <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                            </Button>;
                                        case "DIALOGADD":
                                            var saveCb = (leadResponse) => {
                                                //context.loadLead(leadResponse.result.idLead);
                                                context.getLeads(3000, true, () => {
                                                    //showDtSelID("tableLeads", data.result.idLead);
                                                });
                                            };

                                            return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                <i className="fa fa-user-plus fa-lg"></i>{context.props.i18nManager.t("lead.add")}
                                            </Button>;
                                        default: return "";
                                    }
                                }
                                else return "";
                            })}
                            {<span className="ms-1">{`${filteredLeads.length} élément(s) ${(validLeads.length - filteredLeads.length) > 0 ? ("(filtré de " + validLeads.length + " éléments au total)") : ""}`}</span>}
                            <div className="float-end mb-1 mt-2">
                                <div className={`form-check form-check-inline fcheck-sm form-group float-sm-end m-0 ms-2 me-4 mt-1`}>
                                    <Label check for={"onlyactives"} className={`d-inline-block px-0 w-100`} style={{ minWidth: "16px" }}>
                                        <div className={`d-inline-block me-2 px-0`}>{context.props.i18nManager.t("lead.onlyactivesFilter")}</div>
                                        <div className={`d-inline-block`} style={{ position: "relative", top: "-12px" }}>
                                            <Input type="checkbox" id={"onlyactives"} checked={context.state.onlyActives} onChange={(e) => {
                                                context.setState({ onlyActives: e.target.checked });
                                            }} />
                                            <span className={`form-check-sign`} />
                                        </div>
                                    </Label>
                                </div>
                                <div className="float-sm-end">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectAssignSite"}>{context.props.i18nManager.t("lead.assignSiteFilter")}</Label>
                                    <Input id={"selectAssignSite"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                        var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                        var curFilter = selValue;
                                        context.setState({ assignSiteFilter: parseInt(curFilter) });
                                    }} value={context.state.assignSiteFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];

                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.extSite?.name;
                                                var value = row.assignSiteID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });

                                            //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(allOpt);

                                            return options.map((option, index) => {
                                                return <option className={`${option.hidden ? "d-none" : ""}`} key={index} value={option.value}>
                                                    {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                    {option.title}
                                                </option>
                                            });
                                        })()}
                                    </Input>
                                </div>
                                <div className="float-sm-end">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectService"}>{context.props.i18nManager.t("lead.serviceFilter")}</Label>
                                    <Input id={"selectService"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                        var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                        var curFilter = selValue;
                                        context.setState({ serviceFilter: parseInt(curFilter) });
                                    }} value={context.state.serviceFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];

                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.service?.name;
                                                var value = row.serviceID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });

                                            //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(allOpt);

                                            return options.map((option, index) => {
                                                return <option className={`${option.hidden ? "d-none" : ""}`} key={index} value={option.value}>
                                                    {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                    {option.title}
                                                </option>
                                            });
                                        })()}
                                    </Input>
                                </div>
                                <div className="float-sm-end">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"inputSearch"}>{context.props.i18nManager.t("lead.inputSearchFilter")}</Label>
                                    <Input id={"inputSearch"} bsSize="sm" className={`w-auto d-inline-block`} placeholder={context.props.i18nManager.t("lead.inputSearchHolder")} type="text" style={{ maxWidth: "200px" }} autoComplete="off" aria-autocomplete="none" onChange={(e) => {
                                        var curFilter = e.target.value;
                                        context.setState({ searchField: curFilter });
                                    }}>
                                    </Input>
                                </div>
                            </div>
                            <div style={{ clear: "both" }}></div>
                            {filteredLeads.map(lead => {
                                try {
                                    /*const statusHistory = [
                                        { status: "nouveau", date: "2024-06-20T10:00:00", note: "Premier contact établi" },
                                        { status: "en_cours", date: "2024-06-22T14:30:00", note: "Analyse des besoins" },
                                        { status: "tarifs_envoyes", date: "2024-06-25T16:45:00", note: "Devis envoyé par email" }
                                    ];
            
                                    const customStatusConfig = {
                                        nouveau: {
                                            label: "Nouveau",
                                            icon: "fa fa-user",
                                            color: "primary",
                                            bgColor: "#007bff",
                                            textColor: "#0056b3"
                                        }
                                        // ... autres statuts personnalisés
                                    };*/

                                    const statusHistory = lead.flows;

                                    var statusOrder = [3001, 3002, 3003, 3004, 3007, 3008, 3009, 3005, 3006];

                                    //TEMP - Tarifs
                                    var hasPrices = lead.extras.filter(extra => extra.name === "generatePrices" && extra.value === "true");
                                    hasPrices = hasPrices.length > 0;
                                    if (!hasPrices) statusOrder = statusOrder.filter(status => status !== 3003);

                                    //TEMP - Visite
                                    var shouldVisit = lead.serviceID === 801;
                                    if (!shouldVisit) statusOrder = statusOrder.filter(status => status !== 3004 && status !== 3007);


                                    var customStatusConfig = {};
                                    context.state.status?.forEach(status => {
                                        if ((hasPrices || status.idStatus !== 3003) && (shouldVisit || (status.idStatus !== 3004 && status.idStatus !== 3007))) {
                                            customStatusConfig[status.idStatus] = status;
                                        }

                                        var statusObj = status;
                                        if (!statusObj.bgColor && statusObj.css) {
                                            switch (true) {
                                                case statusObj.css.indexOf("purple-300") >= 0:
                                                    statusObj.bgColor = "#BA68c8";
                                                    break;
                                                case statusObj.css.indexOf("amber-600") >= 0:
                                                    statusObj.bgColor = "#ffb300";
                                                    break;
                                                case statusObj.css.indexOf("cyan-600") >= 0:
                                                    statusObj.bgColor = "#00acc1";
                                                    break;
                                                case statusObj.css.indexOf("green-400") >= 0:
                                                    statusObj.bgColor = "#66bb6a";
                                                    break;


                                                case statusObj.css.indexOf("bg-danger") >= 0:
                                                    statusObj.bgColor = "#DC3545";
                                                    break;
                                                case statusObj.css.indexOf("bg-success") >= 0:
                                                    statusObj.bgColor = "#198754";
                                                    break;
                                                case statusObj.css.indexOf("bg-primary") >= 0:
                                                    statusObj.bgColor = "#0D6EFD";
                                                    break;
                                                case statusObj.css.indexOf("bg-secondary") >= 0:
                                                    statusObj.bgColor = "#6C757D";
                                                    break;
                                                case statusObj.css.indexOf("bg-info") >= 0:
                                                    statusObj.bgColor = "#0DCAF0";
                                                    break;
                                                case statusObj.css.indexOf("bg-warning") >= 0:
                                                    statusObj.bgColor = "#FFC107";
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                        //if (!statusObj.textColor) statusObj.textColor = "#000000";
                                        if (!statusObj.textColor) statusObj.textColor = statusObj.bgColor;


                                        var classFa = "";
                                        if (statusObj.css?.indexOf("fa-")) {
                                            statusObj.css.split(" ").forEach((classElem) => {
                                                //console.debug(classElem.startsWith("fa-") + classElem);
                                                classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                            });
                                            if (classFa) statusObj.icon = "fa " + classFa;
                                        }
                                    });
                                    if (customStatusConfig[3004] && lead.extras) {
                                        var visitExtras = lead.extras.map(ext => {
                                            if (ext.name === "visiteDate") return commonFunc.formatDateTime(commonFunc.restStringToDate(ext.value), true);
                                            if (ext.name === "visitItv") return ext.value;
                                            return null;
                                        }).filter(ext => ext !== null);
                                        customStatusConfig[3004 + "tooltip"] = { title: "Visite", value: visitExtras };
                                    }
                                    if (customStatusConfig[3006] && lead.extras) {
                                        var lossExtras = lead.extras.filter(ext => ext.name === "lossReason");
                                        if (lossExtras.length) {
                                            customStatusConfig[3006 + "tooltip"] = { title: "Perdu", value: lossExtras[0].value };
                                        }
                                    }


                                    var saveCb = () => {
                                        //context.loadLead(leadResponse.result.idLead);
                                        context.getLeads(3000, true, () => {
                                            //showDtSelID("tableLeads", data.result.idLead);
                                        });
                                    };

                                    var filesAltObj = {};
                                    if (context.filesType) filesAltObj.filesType = context.filesType;
                                    else filesAltObj.altFilesTypes = "../api/lead/GetLeadFilesType";

                        /*if (lead.leadFiles?.length)*/ filesAltObj.files = lead.leadFiles.map(file => file.file.categ !== "RCP" ? file.file : null).filter(file => file !== null);


                                    var notifDate = commonFunc.restStringToDate(lead.dSysNotif);

                                    var supStyle = {};
                                    var leftColor = customStatusConfig[lead.statusID]?.bgColor || "#6C757D";
                                    if (leftColor) supStyle.borderLeft = "3px solid " + leftColor;
                                    return <Card key={lead.idLead} className={`card-${lead.idLead}`} style={lead.priority > 0 ? { backgroundColor: "rgba(255, 0, 24, 0.05)", ...supStyle } : { ...supStyle }}>
                                        <CardHeader>
                                            <Row>
                                                <Col className="col-12 col-sm-2 col-lg-1 me-3 pe-0" style={{ maxWidth: "100px" }}>{lead.priority > 0 ? <><i className="fa fa-circle" style={{ color: "red" }}></i><div>Prioritaire</div></> : ""}</Col>
                                                <Col>
                                                    <h5 className="fw-bold mb-0">{lead.client?.name + " - " + lead.service?.name/*lead.title*/}</h5>
                                                    <div>{lead.client?.name + " " + lead.client?.firstName}</div>
                                                    <div>{lead.tel || ""}</div>

                                                    {(lead.dSysNotif !== lead.dSysCreat && commonFunc.isValidDate(notifDate) && notifDate.getFullYear() > 1970) ? <Badge className="" color="warning"><i className="fa fa-clock me-2"></i>{`Rappel le ${commonFunc.formatDateTime(moment(notifDate).utc(true).toDate())}`}</Badge> : ""}
                                                </Col>
                                                <Col className="col-12 col-sm-auto align-items-end text-end">
                                                    <h6 className="fw-bold m-0">{lead.extSite?.name}</h6>
                                                    <div className="text-secondary" style={{ fontSize: "12px" }}>Dernière activité : {moment(lead.dSysMod).format("DD/MM/YYYY")}</div>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <WidgetBreadcrumb
                                                srcTag={lead.idLead}
                                                srcData={lead}
                                                currentStatus={lead.statusID}
                                                statusHistory={statusHistory}
                                                statusOrder={statusOrder}
                                                statusConfig={customStatusConfig}
                                                showDates={true}
                                                showTooltips={true}
                                                variant="horizontal" // ou "vertical"
                                                size="md" // "sm", "md", ou "lg"
                                                altCreateStatus={[3001, 3002]}
                                                lastStatus={[3005, 3006]}
                                            />

                                            <Row>
                                                {context.props.checkRights("LEAD", "S") ? <Card className={`my-3 p-3 col-6 lead-${lead.statusID}`} style={{ backgroundColor: "#1B57710E", color: "#014051" }}>
                                                    <div className="p-2"><i className="fa fa-plus me-2"></i>Prochaines actions</div>
                                                    <div>
                                                        {shouldVisit && (lead.status.step <= 2 || lead.statusID === 3003) && <Button className="m-0 me-2 mt-2" size="sm" color="primary" onClick={() => { dialogAltLead(context.props.i18nManager.t("lead.scheduleVisit"), "SCHEDULEVISIT", lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}><i className="fa fa-calendar me-2"></i>Planifier visite</Button>}
                                                        {shouldVisit && lead.statusID === 3004 && <Button className="m-0 me-2 mt-2" size="sm" color="primary" onClick={() => { context.updateLeadStatus(3007, -1, "Visite réalisée", lead.idLead); }}><i className="fa fa-map-marker-alt me-2"></i>Visite réalisée</Button>}
                                                        {hasPrices && lead.status.step <= 2 && <Button className="m-0 me-2 mt-2" size="sm" color="primary" onClick={() => { context.manageShopOrder(lead, context); }}><i className="fa fa-euro me-2"></i>Envoyer les tarifs</Button>}

                                                        {lead.status.step === 3 && lead.statusID !== 3004 && <Button className="m-0 me-2 mt-2" size="sm" color="primary" onClick={() => { context.updateLeadStatus(3008, -1, "Liste d'attente", lead.idLead); }}><i className="fa fa-pause me-2"></i>Liste d'attente</Button>}

                                                        {(lead.statusID === 3003 || lead.statusID === 3007 || lead.statusID === 3008) && <Button className="m-0 me-2 mt-2" size="sm" color="primary" onClick={() => { context.updateLeadStatus(/*3009*/3005, -1, "Intervention Planifiée", lead.idLead); }}><i className="fa fa-calendar-check me-2"></i>Intervention Planifiée</Button>}
                                                        {(lead.statusID === 3009) && <Button className="m-0 me-2 mt-2" size="sm" color="success" onClick={() => { context.updateLeadStatus(3005, -1, "Prospect transformé", lead.idLead); }}><i className="fa fa-check me-2"></i>Transformé Prospect</Button>}

                                                        {/*lead.status.step > 2 &&*/ lead.status.step < 5 /*&& lead.statusID !== 3009*/ && <Button className="m-0 me-2 mt-2" size="sm" color="danger" onClick={() => { dialogAltLead(context.props.i18nManager.t("lead.leadloss"), "LEADLOSS", lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}><i className="fa fa-ban me-2"></i>Prospect Perdu</Button>}
                                                    </div>
                                                    <div><Button className="" color="secondary" size="sm" onClick={() => { context.generateLeadRecap(lead) }}><i className="fa fa-file-pdf"></i> Générer un récap.</Button></div>
                                                </Card> : ""}
                                                {context.props.checkRights("LEAD_FILES", "L") ? <Col xs="6">
                                                    <div>Fichiers :</div>
                                                    <FilesCustom className={"lead-files" + lead.idLead} bindID={lead.idLead} rightType={"LEAD_FILES"} checkRights={context.props.checkRights} fileTypeID="LEAD" src={lead}
                                                        waitForCompletion={(fileUpReq) => { return fileUpReq.ftype === "DVS"; }} srcName={lead.title} withFilters noUploadBtn
                                                        shouldRender badgeRendering noRemove defaultFileType={"DVS"} {...filesAltObj}
                                                        altFilesUrl="../api/lead/GetLeadFiles" altRemoveFilesUrl="../api/lead/RemoveLeadFile" altUploadFilesUrl="../api/lead/UploadLeadFiles" />
                                                </Col> : ""}
                                            </Row>

                                            {context.props.checkRights("LEAD", "A") ? <><Button href={`callto:${lead.client.tel}`} className="btn-simple" size="sm" color="primary"><i className="fa fa-phone me-2"></i>Appeler</Button>
                                                <Button href={`mailto:${lead.client.email}`} className="btn-simple d-none" size="sm" color="dark"><i className="fa fa-envelope me-2"></i>Email</Button>
                                                <Button className="btn-simple" size="sm" color="dark" disabled={lead.statusID >= 3004} onClick={() => { sendEmailDialog(lead, context.props.dataCfg, context.props.i18nManager); }}><i className="fa fa-envelope me-2"></i>Email</Button>

                                                <Button className="btn-simple d-none" size="sm" color="info"><i className="fa fa-comment me-2"></i>Note</Button>
                                            </> : ""}
                                            {context.props.checkRights("LEAD", "U") && (lead.status.step < 4 && lead.statusID !== 3004 && lead.statusID !== 3007) && <Button className="btn-simple d-none2" size="sm" color="info" onClick={() => showDialogLead(altT(templatesWidgetList[0].name), templatesWidgetList[0].tag, lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}><i className="fa fa-edit me-2"></i>Modifier</Button>}
                                            {context.props.checkRights("LEAD", "CU") && lead.status.step < 4 && <Button className="btn-simple d-none2" size="sm" color="success" onClick={() => showDialogLead(altT(templatesWidgetList[0].name.replace("edit", "duplicate")), templatesWidgetList[0].tag, lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager, true)}><i className="fa fa-copy me-2"></i>Dupliquer</Button>}


                                            {context.props.checkRights("LEAD", "R") /*&& !(context.props.checkRights("LEAD", "U") && lead.status.step < 4)*/ && <Button className="btn-simple" size="sm" color="secondary" onClick={() => { dialogAltLead(context.props.i18nManager.t("lead.tabDetails"), "DLG_LEAD", lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}><i className="fa fa-circle-info me-2"></i>Consulter</Button>}

                                            {context.props.checkRights("LEAD_FLOWS", "L") && <Button className="btn-simple" size="sm" color="warning" onClick={() => { context.showFlows(lead.idLead, lead); }}><i className="fa fa-clock-rotate-left me-2"></i>Historique</Button>}

                                        </CardBody>
                                    </Card>;
                                }
                                catch (e) {
                                    console.error(e);
                                    return <div className="badge badge-danger my-3">Une erreur est survenu lors du chargement de ce widget {"- " + lead.idLead + " " + lead.client?.name + " - " + lead.service?.name/*lead.title*/}</div>
                                }
                            })}
                        </div>;
                }
                else {
                    return "";
                }
            }
            catch (e) {
                console.error(e);
                return <div>Une erreur est survenu lors du chargement de la liste widget</div>
            }
        }
        else {
            let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                <div>
                    {this.leadModels ? <CDataTable key="leads" dtId={"tableLeads"} data={filteredLeads} localConfig={dtConfig} tag={"DT_LEADS"} config={this.leadModels["DT_LEADS"]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                        className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} attrSup={{ "dt-filter-target": ("tableLeads_filters") }} /> : ""}
                </div>;

            return (
                <div className="tableDetails">
                    {context.state.switchDisplay ? <Button className="btn-icon btn-round mt-0" color="primary" onClick={() => {
                        context.getLeads(3000, true, () => {
                            //showDtSelID("tableLeads", data.result.idLead);
                        });
                        context.setState({ switchDisplay: !context.state.switchDisplay, serviceFilter: -1, searchField: "", onlyActives: true, dataStamp: new Date().getTime() });
                    }}><i className="fa fa-columns"></i></Button> : ""}
                    <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                        <CardHeader>
                            <CardTitle tag="h6">{context.props.i18nManager.t("lead.title")}</CardTitle>
                            <div className="widget-tools collapse-tool">
                                <i className="fa fa-table-list fa-4x"></i>
                            </div>
                            <div className='borderTheme'></div>
                        </CardHeader>
                        <CardBody>
                            <div className="float-start">
                                <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getLeads()}>
                                    <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                                </Button>
                                {pageConfig?.templates?.map((template, index) => {
                                    if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                        switch (template.subType) {
                                            case "ADD":
                                                return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateLead()}>
                                                    <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("lead.add")}
                                                </Button>;
                                            case "DIALOGADD":
                                                var saveCb = (leadResponse) => {
                                                    //context.loadLead(leadResponse.result.idLead);
                                                    context.getLeads();
                                                };

                                                return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => showDialogLead(altT(template.name), template.tag, null, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                    <i className="fa fa-user-plus"></i>{context.props.i18nManager.t("lead.add")}
                                                </Button>;
                                            default: return "";
                                        }
                                    }
                                    else return "";
                                })}
                            </div>
                            <CNavbar className="float-end">
                                <div className="text-end">
                                    {this.state.status.map((dt) => {

                                        //TODO : statusBtnAltProc

                                        var statusClass = "form-badge-radio mb-1 ";
                                        statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                        return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                            <div className='form-check-radio fcheck-sm mb-0'>
                                                <Label check >
                                                    <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                        var value = parseInt(e.target.value);

                                                        context.setState({ curStatus: value, curLeadId: 0, curLead: null, isShowDetails: false });
                                                    }} />
                                                    <span className="form-check-sign" />
                                                    {(() => {
                                                        var classFa = "";
                                                        if (dt.css && dt.css.indexOf("fa-")) {
                                                            dt.css.split(" ").forEach((classElem) => {
                                                                //console.debug(classElem.startsWith("fa-") + classElem);
                                                                classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                            });
                                                        }
                                                        return <i className={`fa ${classFa} me-1`}></i>
                                                    })()}
                                                    {altT(dt.name)}
                                                </Label>
                                            </div>
                                        </div> : "";
                                    })}
                                </div>
                            </CNavbar>
                            <div id={"tableLeads_filters"} className="d-none w-auto p-0">
                                {context.state.altMode && <div className="d-inline-block">
                                    <Label className={`px-0 m-0 d-inline-block mx-2`} for={"selectAssignSiteT"}>{context.props.i18nManager.t("lead.assignSiteFilter")}</Label>
                                    <Input id={"selectAssignSiteT"} bsSize="sm" className={`w-auto d-inline-block`} type="select" style={{ maxWidth: "200px" }} onChange={(e) => {
                                        var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                                        var curFilter = selValue;
                                        context.setState({ assignSiteFilter: parseInt(curFilter), dataStamp: new Date().getTime() });
                                    }} value={context.state.assignSiteFilter}>
                                        {(() => {
                                            var allOpt = { selected: true, title: "Tous", value: -1 };
                                            var options = [];

                                            var values = {};
                                            validLeads.forEach((row) => {
                                                var label = row.extSite?.name;
                                                var value = row.assignSiteID;
                                                if (value && label && !values[value]) {
                                                    values[value] = value;
                                                    options.push({ title: label, value: value });
                                                }
                                            });

                                            //if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                            options.unshift(allOpt);

                                            return options.map((option, index) => {
                                                return <option className={`${option.hidden ? "d-none" : ""}`} key={index} value={option.value}>
                                                    {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                                    {option.title}
                                                </option>
                                            });
                                        })()}
                                    </Input>
                                </div>}
                            </div>
                            {contents}
                        </CardBody>
                    </Card>

                    {this.state.isShowDetails ? (<div className="detailsContainer">
                        <Card className="widget dash text-white" color="theme">
                            <CardHeader>
                                <Row>
                                    <Col lg="10" className="offset-lg-1">
                                        <CardTitle tag="h6" className="text-center">
                                            {this.state.title}
                                        </CardTitle>
                                    </Col>
                                    <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                        <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                            var prevId = context.state.curLeadId || 0;
                                            showDtPrevID("tableLeads", prevId);
                                        }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                        <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                            var prevId = context.state.curLeadId || 0;
                                            showDtNextID("tableLeads", prevId);
                                        }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                    {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : ""))}
                                </Nav>
                            </CardBody>
                        </Card>
                        <TabContent activeTab={this.state.activeTab}>
                            {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? getSysCpt(template, index + 1) : "")}
                        </TabContent></div>) : ""}
                </div>
            );
        }
    }

    async getLeads(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ leads: [], curLeadId: 0, curLead: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus;


        if (context.state.categoryGroupKey) args.categoryGroupKey = context.state.categoryGroupKey;

        if (context.state.altMode) {
            args.level = 3;
            if ((!context.state.switchDisplay || statusId === 3000) /*&& args.state==3001*/) {
                //args.level = 3;
                args.state = 3000;
            }
        }

        commonFunc.getMethod("../api/lead/GetLeads", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();

                    var results = response.data.result;
                    //TEMP
                    if (context.state.pageModels === "PROJECTLEAD") {
                        var tempFile = { "file": { "bindID": 45, "bindType": "LEAD", "fileTypeID": 9, "fileType": null, "siteID": 1, "tenantID": "c9566ead-fbb2-4973-90a0-a733952ac27a", "site": null, "tenantUserAccessID": 1399, "tenantUserAccess": null, "filesReportItv": [], "filesClient": [], "filesEmployee": [], "filesEntity": [], "filesSite": [], "filesLead": [], "filesMaterial": [], "filesTicket": [], "idFile": 41433, "name": "82_COUTANT_17173419.pdf", "prefix": "OskalaRDI\\Invoices\\82\\Fichiers\\", "absoluteUri": "iUX0XWgQ1YhZ3GLtKgvgYIy2mAJvKgjIEFLpyRUDXF5ob+Ves4bqz5IgnrbHDGsrrWri3eBM5pPo6toofirPPOj6BuxYSr8Aj6SHCynXB9l127C7btktfSDcj4Esoy/rb1o05tAXsvMDqxQn0pgVoScVznvQSFvjJsKswrCE2c3OKB5X4ronyTkCwLo+dvjgWMLmxrBmBojjJDFBMWBHgEIp8Or9Z38wUtKJbBEBBloNLaXeEPz/82d7k4pMjMU9BvwRVhT0xq7B9Awam1Cts7z9o657IqrERYNxvSaTMzYHIIAnyQWP/ALZGgK+uqXHI3BVzWzIr1UPnp8QhO6VrMuBYSJdkevNjA9kgTx/2HXdIV+Jyz5bw/xZvohcRz66hBopL40oKbp4MaSuju1V8Ii3cbmM77zB2GF84VtSfOxEgYLcFQ3r1hvpsgpCe8WR1VKG71mHJSoCyRJZtsRknyTvpYCKflFWM2U9uZA3+4LQiQtKFSqVKwfUz4Gx2MUI/Td3whgPx+HYN7gqTEiV5XrwDb6gzH8bshxXsSf/16gxMlpRd8fk1q4ClVISSyzuaNEwkJNCQ9/yESi2coTXJRPikn69kBsa0cl8t7N9Rwd+z8lhPknAv7r6aQKpAlAmlP/ygHGpDROkldqKQ9B4Ig==", "categ": "PDF", "lang": "FR", "rootContainer": "tenant312", "length": 52278, "contentType": "application/pdf", "lastModified": "2025-07-17T15:34:19.174186", "dSysMod": "2025-07-17T15:34:19.216844", "eTag": "\"0x8DDC5476573402A\"", "extension": ".PDF", "hashUri": "", "directDownloadUri": "", "hashMD5": "", "isBlock": true, "isEncrypted": false, "isFile": true, "isHosted": true, "isHidden": false, "userID": 1553, "rawData": null, "keyWords": "", "tag": "" }, "leadID": 45, "fileID": 41433, "dSysMod": "2025-07-17T15:34:19.218311", "isAvailable": true, "isReadOnly": false, "siteID": 1, "site": null };


                        results = [{
                            title: "Terrain 332m² - 12 rue de la Paix", extRef: "PARIS 2E - 2024-0142", description: "485 000 €", startDate: "2024-12-15T02:00:00.00", categoryID: 1, category: { name: "Compromis" },
                            persons: [
                                {
                                    clientID: 1, client: { "name": "Dupont", firstName: "Jean", email: "j.dupont@email.fr", tel: "06 12 34 56 78" }, groupID: 3, group: { "title": "Propriétaire" }, recall: 2,
                                    versions: [{
                                        statusID: 3097, recall: 1, idLead: 3, status: { step: 99 }, leadFiles: [], flows: [{ dSysMod: "2024-12-14T02:00:00.00", statutID: 3097, title: "UpdateStatus", name: "Prix renégocié 490k → 485k", tenantUserAccess: { "name": "LEBLANC_Roméo" } }, { dSysMod: "2024-12-15T02:00:00.00", statutID: 3001, title: "UpdateStatus", tenantUserAccess: { "name": "LEBLANC_Roméo" } }]
                                    }, {
                                        statusID: 3002, recall: 2, idLead: 4, status: { step: 2 }, leadFiles: [tempFile, tempFile], flows: [{ dSysMod: "2024-12-15T02:00:00.00", statutID: 3001, title: "UpdateStatus", tenantUserAccess: { "name": "LEBLANC_Roméo" } }]
                                    }], idLead: 2
                                },
                                {
                                    clientID: 1, client: { "name": "Martin", firstName: "Sophie", email: "s.martin@email.fr", tel: "06 98 76 54 32" }, groupID: 3, group: { "title": "Propriétaire" }, recall: 1,
                                    versions: [{
                                        statusID: 3004, recall: 1, idLead: 6, status: { step: 3 }, leadFiles: [tempFile], flows: [{ dSysMod: "2024-12-15T02:00:00.00", statutID: 3001, title: "UpdateStatus", tenantUserAccess: { "name": "LEBLANC_Roméo" } }]
                                    }], idLead: 5
                                },
                                {
                                    clientID: 1, client: { "name": "Marc", firstName: "Bertrand", email: "m.bertrand@email.fr", tel: "06 55 44 33 22" }, groupID: 3, group: { "title": "Propriétaire" }, recall: 3,
                                    versions: [{
                                            statusID: 3006, recall: 1, idLead: 8, status: { step: 4 }, leadFiles: [], flows: [{ dSysMod: "2024-12-15T02:00:00.00", statutID: 3001, title: "UpdateStatus", tenantUserAccess: { "name": "LEBLANC_Roméo" } }]
                                        }, {
                                            statusID: 3097, recall: 2, idLead: 9, status: { step: 99 }, leadFiles: [], flows: [{ dSysMod: "2024-12-14T02:00:00.00", statutID: 3097, title: "UpdateStatus", name: "Diagnostics mis à jour", tenantUserAccess: { "name": "LEBLANC_Roméo" } }, { dSysMod: "2024-12-15T02:00:00.00", statutID: 3001, title: "UpdateStatus", tenantUserAccess: { "name": "LEBLANC_Roméo" } }]
                                        }, {
                                            statusID: 3004, recall: 3, idLead: 10, status: { step: 3 }, leadFiles: [], flows: [{ dSysMod: "2024-12-15T02:00:00.00", statutID: 3001, title: "UpdateStatus", tenantUserAccess: { "name": "LEBLANC_Roméo" } }]
                                        }], idLead: 7
                                }
                            ], idLead: 1
                        }];
                    }

                    context.setState({ leads: results, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("lead.failLoadLeads") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("lead.failLoadLeads")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/lead/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadLead(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("lead.noSelected"), curLeadId: 0, curLead: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;

            if (context.state.altMode) {
                args.level = 3;
            }
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                commonFunc.getMethod("../api/lead/GetLead", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        if (callback && typeof (callback) === "function") { callback(data); }

                        Swal.close();

                        if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.title + " • " + data.result.address.city), curLeadId: id, curLead: data.result, isShowDetails: true });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("lead.failLoadLead") + " :<br>" + data.errorMessage
                        });
                    }
                    resolve(data);
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async contextSaveLead(userLead, isUpdate) {
        var context = this;
        var callback = (leadResponse) => {
            context.loadLead(leadResponse.result.idLead);
        };

        return saveLead(userLead, context.state.curLead, isUpdate, context.props.i18nManager, callback);
    }

    removeLead(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curLead;
            if ((!id && row) || (id && row && id === row.idLead)) {
                id = id || row.idLead;
                title = row.title;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t("lead.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("lead.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        commonFunc.postMethod("../api/lead/RemoveLead", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getLeads();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateLeadStatus(statusId, stepId, customLabel, overrideLeadID) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = overrideLeadID || context.state.curLeadId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    var reloadLead = true;

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");


                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("lead.updStatus"),
                        html: context.props.i18nManager.t("lead.statusAs", [label]),
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("lead.updatingStatus"),
                                didOpen: () => { Swal.showLoading() },
                            });
                            var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                            commonFunc.postMethod("../api/lead/UpdateStatus", req).then((response) => {

                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    /*context.getLeads(0, true, () => {
                                        if (reloadLead) showDtSelID("tableLeads", id);
                                    });*///TODO : check si besoin de refresh supplémentaire
                                    if (overrideLeadID) context.getLeads();
                                    else {
                                        if (reloadLead) context.loadLead(id);
                                    }
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(response.data);
                            });
                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    manageShopOrder(lead, context) {
        Swal.fire({
            title: "Génération tarifs en cours...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var id = lead.idLead;

        var req = { id: id, waitForCompletion: true/*, templateID: -1, useCascade: false*/ };
        commonFunc.postMethod("../api/lead/GenerateShopOrder", req).then((response) => {
            var data = response.data;
            if (data && data.isSuccess && data.extraInfo) {
                commonFunc.getMethod("../api/lead/GetLeadFiles", { bindID: id, fileId: data.extraInfo.idFile }).then((response) => {
                    Swal.close();
                    var dataFile = response.data;
                    if (dataFile && dataFile.isSuccess && dataFile.result?.length) {
                        var dt = dataFile.result[0];
                        const file = {
                            fileId: dt.idFile,
                            fileName: dt.name,
                            container: dt.rootContainer,
                            etag: dt.etag,
                            accessToken: dt.absoluteUri,
                            newWindow: false
                        };
                        var filePath = "/api/data/DownloadFileByUri?" + commonFunc.toParams(file);

                        var callbackModal = function (data) {
                            console.debug(data);

                            if (data) {
                                context.modalRoot.unmount();
                            }
                            else {
                                context.modalRoot.unmount();
                            }

                            context.getLeads(3000, true, () => {
                                //showDtSelID("tableLeads", data.result.idLead);
                            });
                        };

                        context.modalRoot = createRoot(document.createElement('div'));
                        context.modalRoot.render(<PreviewModal parentContext={this} lead={lead} title={"Aperçu Tarifs"} url={filePath} successBtnCb={() => { context.modalRoot.unmount(); context.updateLeadStatus(3003, -1, "Envoi des tarifs", id); }} callback={callbackModal}></PreviewModal>);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_fail"),
                            html: "Echec de récupération du fichier tarifs<p>" + response.data.errorMessage + "</p>",
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: "Echec de la génération des tarifs<p>" + response.data.errorMessage + "</p>",
                });
            }
        });
    }

    showFlows(idElem, rowData) {
        var context = this;

        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }

        if (parseInt(idElem) > 0) {
            //Traitement des informations retourné par le Dialog
            var callbackModal = function (dataElem, isUpdate) {
                context.modalRoot.unmount();
            };

            context.modalRoot = createRoot(document.createElement('div'));
            context.modalRoot.render(<FlowsModal t={context.props.i18nManager.t} rowData={rowData} dataFlows={rowData.flows} title={context.props.i18nManager.t("lead.tabFlows")} idElem={idElem} parentContext={context} callback={callbackModal} />);

        }
        else {
            Swal.fire({
                icon: "error",
                title: context.props.i18nManager.t("gal_error"),
                html: context.props.i18nManager.t("gal_invalidID")
            });
        }
    }

    generateLeadRecap(lead) {
        var context = this;

        Swal.fire({
            title: context.props.i18nManager.t("gal_processing"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });

        var req = { id: lead.idLead, modelExtID: "PREVIEW-NONE-184519567-1", waitForCompletion: true };//UseAI/UseCascade
        return commonFunc.postMethod("../api/lead/GenerateLeadFile", req).then((response) => {
            var data = response.data;
            if (data && data.isSuccess && data.result) {
                commonFunc.getMethod("../api/lead/GetLeadFiles", { bindID: lead.idLead, fileId: data.result.idFile }).then((response) => {
                    Swal.close();
                    var dataFile = response.data;
                    if (dataFile && dataFile.isSuccess && dataFile.result?.length) {
                        var dt = dataFile.result[0];
                        const file = {
                            fileId: dt.idFile,
                            fileName: dt.name,
                            container: dt.rootContainer,
                            etag: dt.etag,
                            accessToken: dt.absoluteUri,
                            newWindow: false
                        };
                        var filePath = "/api/data/DownloadFileByUri?" + commonFunc.toParams(file);

                        var callbackModal = function (data) {
                            console.debug(data);

                            if (data) {
                                context.modalRoot.unmount();
                            }
                            else {
                                context.modalRoot.unmount();
                            }

                            context.getLeads(3000, true, () => {
                                //showDtSelID("tableLeads", data.result.idLead);
                            });
                        };

                        context.modalRoot = createRoot(document.createElement('div'));
                        context.modalRoot.render(<PreviewModal parentContext={this} hideEmail lead={lead} title={"Aperçu Récap."} url={filePath} callback={callbackModal}></PreviewModal>);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_fail"),
                            html: "Echec de récupération du fichier récap.<p>" + response.data.errorMessage + "</p>",
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: "Echec de la génération du récap.<p>" + response.data.errorMessage + "</p>",
                });
            }
        });
    }



    initCreateLead() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableLeads");
        //this.leadGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("lead.create"), curLeadId: 0, curLead: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;

        /*if (!numTab) {
            var tabIndex = 1;
            pageConfig.templates.forEach((template, index) => {
                if (template.subType === entity) tabIndex = index + 1;
            });
            numTab = tabIndex;
        }*/

        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curLead ? this.state.curLead.title : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("lead.duplicate") : this.props.i18nManager.t("lead.edit")) + " - " + title, editionMode: value });
    }
}

export async function saveLead(userLead, dataLead, isUpdate, i18nManager, callback) {
    dataLead = dataLead || {};

    Swal.fire({
        title: i18nManager.t("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });

    if (isUpdate) {
        userLead.dSysCreat = dataLead.dSysCreat;
    }
    else {
        userLead.dSysCreat = new Date();
    }

    var resetNestedFields = ["category", "site", "extraSite", "client", "status", "subStatus", "tenantUserAccess", "group", "service", "flows"];//userLead.allowNestedUpdate = ["client"];
    if (!userLead.avoidMerge) {
        userLead = commonFunc.mergeDeep({}, dataLead, userLead);

        resetNestedFields.forEach((resetField) => {
            if (!(userLead.allowNestedUpdate?.length && userLead.allowNestedUpdate.indexOf(resetField) >= 0)) {
                if (resetField === "flows") {
                    userLead.flows = [];
                }
                else userLead[resetField] = null;
            }
            //if (!isUpdate && resetField.startsWith("tenantUserAccess")) delete userLead[resetField];
        });

        //MAJ Client
        if (userLead.client && !userLead.client.avoidMerge) {
            userLead.client = commonFunc.mergeDeep({}, dataLead.client, userLead.client);

            //userSite.contacts = null;
            //userSite.agreements = null;
            //userSite.clientFiles = null;
            //userSite.clientParents = null;
            //userSite.demands = null;
            //userSite.flows = null;
            //userSite.matchesAssigned = null;
            //userSite.models = null;
            userLead.client.accountUser = null;
            userLead.client.billingFirm = null;
            userLead.client.category = null;
            userLead.client.parent = null;
            userLead.client.group = null;
            userLead.client.site = null;
            userLead.client.extraSite = null;
            userLead.client.status = null;
            userLead.client.subStatus = null;
            userLead.client.tenantUserAccess = null;
        }
    }
    userLead.assignSite = null;
    userLead.extSite = null;
    /*if (!userLead.leadFiles)*/ userLead.leadFiles = [];

    //TEMP >> TOREMOVE AFTER MAJ 19/11
    userLead.category = null;
    userLead.site = null;
    userLead.extraSite = null;
    userLead.status = null;
    userLead.subStatus = null;
    userLead.tenantUserAccess = null;

    //Reset Contacts
    if (!isUpdate && userLead.idLead === 0) {
        userLead.contacts = userLead.contacts?.filter(contact => contact.idContact === 0) || [];
        if (userLead.client) userLead.client.contacts = userLead.client.contacts?.filter(contact => contact.idContact === 0) || [];
    }

    if (userLead.contact?.name) {
        if (!userLead.contacts) userLead.contacts = [];
        if (!userLead.contact.idContact) userLead.contact.idContact = 0;
        var checkContact = userLead.contacts.filter(contact => contact.idContact === userLead.contact.idContact);
        if (checkContact.length) checkContact[0] = commonFunc.mergeDeep(checkContact[0], userLead.contact);
        else userLead.contacts.push(userLead.contact);
    }
    if (userLead.client?.contacts) {
        userLead.client.contacts = userLead.client.contacts.filter(ctc => ctc != null);
        userLead.client.contacts.forEach((ctc, index) => {
            if (userLead.client?.contacts_temp?.length) {
                var foundedTempCtc = userLead.client?.contacts_temp?.filter(dCtc => dCtc.idContact === ctc.idContact);
                if (foundedTempCtc?.length) {
                    if (foundedTempCtc[0].idContact) {
                        userLead.client.contacts[index] = commonFunc.mergeDeep({}, ctc, foundedTempCtc[0]);
                    }
                    else userLead.client.contacts[index] = commonFunc.mergeDeep({}, foundedTempCtc[0], ctc);
                }
            }

            var foundedCtc = dataLead?.client?.contacts?.filter(dCtc => dCtc.idContact === ctc.idContact);
            if (foundedCtc?.length) {
                //ctc = commonFunc.mergeDeep({}, foundedCtc[0], ctc);
            }

            /*if (!ctc.address) {
                userLead.client.contacts[index].address = {
                    "addressMain": "N/A",
                    "categ": "SITE",
                    "title": "Adresse",
                    "avoidReset": "true",
                    "idAddress": ctc.addressID || 0
                };
            }*/
            //ctc.clientID = userLead.clientID;
            console.debug(ctc);
        });
    }
    if (userLead.client?.contact?.name) {
        if (!userLead.client.contacts) userLead.client.contacts = [];
        if (!userLead.client.contact.idContact) userLead.client.contact.idContact = 0;

        var checkContactClient = userLead.client.contacts.filter(contact => contact.idContact === userLead.client.contact.idContact);
        if (checkContactClient.length) checkContactClient[0] = commonFunc.mergeDeep(checkContactClient[0], userLead.client.contact);
        else userLead.client.contacts.push(userLead.client.contact);

        if (userLead.client.contact.idContact <= 0) {
            //Duplique le contact client sur le lead
            if (!userLead.contacts) userLead.contacts = [];
            userLead.contacts.push(userLead.client.contact);
        }
        else if (userLead.contacts) {
            //Récupération des modifications contact client pour contact lead
            var commonContact = userLead.contacts.filter(contact => contact.contactType === userLead.client.contact.contactType);
            if (commonContact.length === 1) {
                commonContact[0].title = userLead.client.contact.title;
                commonContact[0].name = userLead.client.contact.name;
                commonContact[0].firstName = userLead.client.contact.firstName;
                commonContact[0].tel = userLead.client.contact.tel;
                commonContact[0].gsm = userLead.client.contact.gsm;
                commonContact[0].email = userLead.client.contact.email;
                commonContact[0].comments = userLead.client.contact.comments;
                commonContact[0].extLink = userLead.client.contact.extLink;
            }
        }
    }
    if (userLead.client) userLead.client.idClient = userLead.clientID;

    //Gestion ForcedCreate
    /*var forcedCreate = (userLead.idLead && !isUpdate) ? userLead.idLead : 0;
    if (forcedCreate) {
        userLead.idLead = 0;
        userLead.statusID = 3002;
        userLead.extras.forEach(extra => {
            extra.idExtra = 0;
            extra.leadID = 0;
        });
    }*/


    console.debug(userLead);
    //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
    return commonFunc.postMethod(isUpdate ? "../api/lead/UpdateLead" : "../api/lead/CreateLead", userLead).then((response) => {
        return new Promise((resolve, reject) => {
            var data = response.data;
            if (data?.isSuccess) {

                var finalizeLeadProc = () => {
                    Swal.fire({
                        icon: "success",
                        title: i18nManager.t("gal_success"),
                        html: (isUpdate ? i18nManager.t("gal_successUpd") : i18nManager.t("gal_successAdd")),
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        /*if (context.state.curStatus !== data.result.statusID) {
                            context.setState({ curStatus: data.result.statusID });
                            context.refreshCb = () => {
                                showDtSelID("tableLeads", data.result.idLead);
                            };
                        }
                        else {
                            context.getLeads(0, true, () => {
                                showDtSelID("tableLeads", data.result.idLead);
                            });
                        }*/
                        if (callback && typeof (callback) === "function") { callback(data); }
                    });

                    data.result.idResponse = data.result.idLead;
                    resolve(data.result);
                };

                var asyncJobs = [];

                //MAJ sous-objets Lead
                if (isUpdate) {
                    /*if (userLead.client) {
                        console.debug(dataLead.client);

                        //MAJ Client
                        if (!userLead.client.avoidMerge) {
                            userLead.client = commonFunc.mergeDeep({}, dataLead.client, userLead.client);

                            //userSite.contacts = null;
                            //userSite.agreements = null;
                            //userSite.clientFiles = null;
                            //userSite.clientParents = null;
                            //userSite.demands = null;
                            //userSite.flows = null;
                            //userSite.matchesAssigned = null;
                            //userSite.models = null;
                            userLead.client.accountUser = null;
                            userLead.client.billingFirm = null;
                            userLead.client.category = null;
                            userLead.client.parent = null;
                            userLead.client.group = null;
                            userLead.client.site = null;
                            userLead.client.extraSite = null;
                            userLead.client.status = null;
                            userLead.client.subStatus = null;
                            userLead.client.tenantUserAccess = null;
                        }

                        console.debug(userLead.client);
                        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                        asyncJobs.push(commonFunc.postMethod("../api/client/UpdateClient", userLead.client).then((response) => {
                            if (response?.data?.errorMessage?.startsWith("Aucun Changement")) response.data.isSuccess = true;
                            return new Promise((resolve, reject) => {
                                resolve(response);
                            });
                        }).catch(error => {
                            return new Promise((resolve) => {
                                resolve({ isSuccess: false, errorMessage: error });
                            });
                        }));

                        //MAJ ClientContact
                        if (userLead.client.contacts?.length) {
                            userLead.client.contacts.forEach(dataElem => {
                                if (!dataElem.avoidMerge) {
                                    dataElem.status = null;
                                    dataElem.category = null;
                                    dataElem.custom = null;
                                    dataElem.parent = null;
                                    dataElem.site = null;
                                    dataElem.extraSite = null;
                                    dataElem.client = null;
                                    dataElem.material = null;//Patch Upd Contact
                                    dataElem.employee = null;//Patch Upd Contract
                                    dataElem.report = null;//Patch Upd Contract
                                    dataElem.lead = null;//Patch Upd Contract
                                    dataElem.ticket = null;//Patch Upd Contract
                                    dataElem.service = null;//Patch Upd Contract
                                }

                                console.debug(dataElem);
                                //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                                asyncJobs.push(commonFunc.postMethod(dataElem.idContact > 0 ? "../api/client/UpdateClientContact" : "../api/client/CreateClientContact", dataElem).then((response) => {
                                    if (response?.data?.errorMessage?.startsWith("Aucun Changement")) response.data.isSuccess = true;
                                    return new Promise((resolve, reject) => {
                                        resolve(response);
                                    });
                                }).catch(error => {
                                    return new Promise((resolve) => {
                                        resolve({ isSuccess: false, errorMessage: error });
                                    });
                                }));
                            });
                        }
                    }*/
                    if (userLead.contacts) {
                        //MAJ LeadContact
                        if (userLead.contacts?.length) {
                            userLead.contacts.forEach(dataElem => {
                                if (!dataElem.avoidMerge) {
                                    dataElem.status = null;
                                    dataElem.category = null;
                                    dataElem.custom = null;
                                    dataElem.parent = null;
                                    dataElem.site = null;
                                    dataElem.extraSite = null;
                                    dataElem.client = null;
                                    dataElem.material = null;//Patch Upd Contact
                                    dataElem.employee = null;//Patch Upd Contract
                                    dataElem.report = null;//Patch Upd Contract
                                    dataElem.lead = null;//Patch Upd Contract
                                    dataElem.ticket = null;//Patch Upd Contract
                                    dataElem.service = null;//Patch Upd Contract
                                }
                                dataElem.leadID = data.result.idLead || userLead.idLead;

                                console.debug(dataElem);
                                //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                                asyncJobs.push(commonFunc.postMethod(dataElem.idContact > 0 ? "../api/lead/UpdateLeadContact" : "../api/lead/CreateLeadContact", dataElem).then((response) => {
                                    if (response?.data?.errorMessage?.startsWith("Aucun Changement")) response.data.isSuccess = true;
                                    return new Promise((resolve, reject) => {
                                        resolve(response);
                                    });
                                }).catch(error => {
                                    return new Promise((resolve) => {
                                        resolve({ isSuccess: false, errorMessage: error });
                                    });
                                }));
                            });
                        }
                    }

                    Promise.all(asyncJobs).then(results => {
                        var errorMessage = false;
                        var flagSuccess = true;
                        results.forEach(res => {
                            if (res && res.data) {
                                flagSuccess &= res.data.isSuccess;
                                if (!res.data.isSuccess) errorMessage = res.data.errorMessage;
                            }
                            else {
                                flagSuccess = false;
                                errorMessage = res.errorMessage;
                            }
                        });

                        if (flagSuccess) {
                            finalizeLeadProc();
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur lors de l'enregistrement des informations :<br>" + errorMessage
                            }).then(() => {
                                if (callback && typeof (callback) === "function") { callback(data); }
                                data.result.idResponse = data.result.idLead;
                                resolve(data.result);
                            });
                        }
                    });
                }
                else {
                    //Suppression Lead pour ForcedCreate
                    /*if (forcedCreate) {
                        commonFunc.postMethod("../api/lead/RemoveLead", { id: forcedCreate, isPermanent: false }).then((response) => {
                            //if (response.data?.isSuccess) {
                            //    var mFiles = { id: id, targetId: removeInfos.id, isPermanent: true };
                            //    postMethod("../api/reports/MigrateFiles", mFiles, function (dataFilesMigration) {
                            //        if (dataFilesMigration.isSuccess) {
    
                            //            if (assignAndSend) {
                            //                //assignDlgItv(id, itv, ad2, callbackRemoveProc);
                            //                assignDlgItv(id, itv, ad2, callbackSaveProc);
                            //            }
                            //            else {
                            //                callbackSaveProc();
                            //            }
                            //        } else {
                            //            Swal.close();
                            //            Swal.fire({
                            //                type: 'error',
                            //                title: "Echec de migration des documents de la pochette d'origine",
                            //                html: "<p>" + dataFilesMigration.errorMessage + "</p>",
                            //            });
                            //        }
                            //    });
                            //} else {
                            //    Swal.close();
                            //    Swal.fire({
                            //        type: 'error',
                            //        title: "Echec de la suppression de la pochette d'origine",
                            //        html: "<p>" + dataRemove.errorMessage + "</p>",
                            //    });
                            //}
                        });
                    }*/

                    finalizeLeadProc();
                }

            } else {
                var supErrors = "";
                if (data.errors && data.errors.length) {
                    supErrors = data.errors.map((error) => {
                        return "<br>" + error.desc + "(" + error.value + ")";
                    });
                }
                Swal.fire({
                    icon: "error",
                    title: i18nManager.t("gal_fail"),
                    html: i18nManager.t("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                });
                resolve(data);
            }
        });
    });
}

export function getLeadModels(categ) {
    return new Promise((resolve, reject) => {
        var args = { filter: "lead", useParentSite: true, excludeMode: 1 };
        if (categ) args.categ = categ;
        commonFunc.getMethod("../api/data/GetAllModels", args).then((responseModels) => {
            var dataModels = responseModels.data;
            if (dataModels.isSuccess) {

                var leadModels = {};
                //dataModels.result.models.forEach((model) => {
                dataModels.result.map(model => model.tag).forEach((model) => {
                    var modelObj = JSON.parse(model.value);
                    if (!modelObj.objType) {//Array.isArray(modelObj)
                        var useSub = false;
                        Object.keys(modelObj).forEach(key => {
                            var subModel = modelObj[key];
                            if (subModel.objType) {
                                useSub = true;
                                leadModels[key] = subModel;
                            }
                        });
                        if (!useSub) leadModels[model.extID] = modelObj;
                    }
                    else leadModels[model.extID] = modelObj;
                });
                resolve({ models: leadModels, response: dataModels });
            }
            else resolve();
        });
    });
}

export function showDialogLead(title, tag, curLead, leadModels, saveLeadVar, saveCb, modalGenManager, parentProps, i18nManager, isDuplicate) {
    var modalRoot;
    //Traitement des informations retourné par le Dialog
    var callbackModal = function (data, isUpdate) {
        return new Promise((resolve, reject) => {
            if (data) {
                //isUpdate = false;//TEMP : Recréation du lead (voir pour les associations client etc..)
                saveLeadVar(data, curLead, isUpdate, i18nManager, saveCb).then((dataResult) => {
                    if (dataResult && dataResult.idResponse) {
                        modalRoot.unmount();
                        resolve(dataResult);
                    }
                    else {
                        resolve(dataResult);
                    }
                });
            }
            else {
                modalRoot.unmount();
                resolve();
            }
        });
    };
    if (leadModels[tag]) {
        if (isDuplicate && !(curLead.parentID > 0)) curLead.parentID = curLead.idLead;

        modalRoot = createRoot(document.createElement('div'));
        //modalRoot.render(<LeadModal modalGenManager={modalGenManager} noScroll noButtons props={parentProps} title={title} dialogBodyStyle2={{ height: "80vh" }} configModel={leadModels[tag]} modelsList={leadModels} dataLead={curLead} callback={callbackModal}></LeadModal>);
        modalRoot.render(<LeadModal modalGenManager={modalGenManager} noScroll noButtons props={parentProps} title={title} dialogBodyStyle2={{ height: "80vh" }} configModel={leadModels[tag]} configTag={tag} modelsList={leadModels} dataLead={curLead} isDuplicate={isDuplicate} i18nManager={i18nManager} callback={callbackModal}></LeadModal>);
    }
    else {
        Swal.fire({
            icon: "error",
            title: i18nManager.t("gal_error"),
            html: "Configuration introuvable"
        });
    }
}

function dialogAltLead(title, tag, curLead, leadModels, process, scheduleVisitCb, modalGenManager, parentProps, i18nManager) {
    var modalRoot;
    //Traitement des informations retourné par le Dialog
    var callbackModal = function (data, isUpdate) {
        return new Promise((resolve, reject) => {
            if (data) {
                var cb = () => {
                    var req = { id: data.idLead, newStatus: (tag === "LEADLOSS" ? 3006 : 3004), newStep: -1 };
                    commonFunc.postMethod("../api/lead/UpdateStatus", req).then((response) => {
                        if (response.data && response.data.isSuccess) {
                            if (scheduleVisitCb && typeof (scheduleVisitCb) === "function") { scheduleVisitCb(data); }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: i18nManager.t("gal_fail"),
                                html: i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                            });
                        }
                        resolve(response.data);
                    });
                };

                process(data, curLead, isUpdate, i18nManager, cb).then((dataResult) => {
                    if (dataResult && dataResult.idResponse) {
                        modalRoot.unmount();

                        resolve(dataResult);
                    }
                    else {
                        resolve(dataResult);
                    }
                });
            }
            else {
                modalRoot.unmount();
                resolve();
            }
        });
    };
    if (leadModels[tag]) {
        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<LeadModal supClasses={"visitModal"} modalGenManager={modalGenManager} noScroll size={"lg"} props={parentProps} title={title} configModel={leadModels[tag]} configTag={tag} locked={tag === "DLG_LEAD"} modelsList={leadModels} dataLead={curLead} i18nManager={i18nManager} callback={callbackModal}></LeadModal>);
    }
    else {
        Swal.fire({
            icon: "error",
            title: i18nManager.t("gal_error"),
            html: "Configuration introuvable"
        });
    }
}

function sendEmailDialog(lead, dataCfg, i18nManager) {
    var id = lead.idLead;
    if (parseInt(id) > 0) {
        var title = i18nManager.t("lead.title") + " • " + lead.title + " • " + lead.client?.name + " " + lead.client?.firstName + (lead.client?.compagny ? (" - " + lead.client?.compagny) : "");// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

        var modalRoot;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function () {
            modalRoot.unmount();
        };

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} leadId={id} lead={lead} dataCfg={dataCfg} i18nManager={i18nManager} callback={callbackModal}></EmailModal>);

    } else {
        Swal.fire({
            icon: "error",
            title: "Echec",
            html: "Aucune intervention n'est sélectionnée dans la liste"
        });
    }
}

export function LeadModal({ title, props, modalGenManager, noScroll, noButtons, noSubmit, supClasses, size, dialogBodyStyle, configModel, configTag, locked, modelsList, dataLead, isDuplicate, i18nManager, callback }) {
    configModel = JSON.parse(JSON.stringify(configModel));

    const [initialized, setInitialized] = React.useState(configTag !== "DLG_LEAD");
    const [dlgLead, setDlgLead] = React.useState(dataLead);


    React.useEffect(() => {
        if (!initialized && configTag === "DLG_LEAD") {
            var args = {};
            //args.id = dataLead?.clientID;
            //args.level = 2;
            args.id = dataLead?.idLead;
            args.level = 3;
            if (parseInt(args.id) > 0) {
                Swal.fire({
                    title: i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                //commonFunc.getMethod("../api/client/GetClient", args).then((response) => {
                commonFunc.getMethod("../api/lead/GetLead", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        Swal.close();

                        if (data.result) {
                            //dataLead.client = data.result;
                            //var newLead = dataLead;
                            var newLead = data.result;
                            newLead.client.contact = newLead.client?.contacts?.filter(contact => {
                                if (!contact.address) contact.address = { "idAddress": contact.addressID, "pc": 0, "city": "", "categ": "SITE", "title": "Adresse", "addressMain": "N/A" };// /!\ TODO : Perte valeur adresse du contact
                                return contact.contactType === "Prospect Appelant";
                            });
                            if (newLead.client?.contact?.length) newLead.client.contact = newLead.client.contact[0];
                            //else if (newLead.client?.contacts?.length) newLead.client.contact = newLead.client.contacts[0];

                            if (isDuplicate && !(newLead.parentID > 0)) newLead.parentID = newLead.idLead;
                            setDlgLead(newLead);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: i18nManager.t("gal_error"),
                            html: i18nManager.t("client.failLoadClient") + " :<br>" + data.errorMessage
                        });
                    }
                    setInitialized(true);
                });

            }
            else {
                setInitialized(true);
            }
        }
    }, []);


    if (locked) {
        configModel.disabled = true;
        configModel.subType = "breadcrumbNav";
        size = "xl";
        noButtons = false;
        noSubmit = true;
    }
    else if (configTag === "DLG_LEAD" && dlgLead) {
        configModel.subType = "breadcrumbNav";
    }

    return (
        <Modal isOpen={true} className={`dlg-step modal-lead ${noScroll ? "modal-noscroll" : ""} ${supClasses}`} size={size ? size : "xl"} scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex"  toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2 pt-0  scrollable" style={{ overflowX: "hidden", ...dialogBodyStyle }}>
                {initialized && <AGenerateModel parentProps={{ type: "lead", dataCfg: props.dataCfg }} ref={modalGenManager} noButtons onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={props} checkRights={props.checkRights} getRoutes={props.getRoutes} configModel={configModel} modelsList={modelsList} loadedData={dlgLead} isStartDuplicate={isDuplicate} />}

                {/*<FilesCustom className="reportDlg-files" title="FICHIERS JOINTS" bindID={elemID} checkRights={props.checkRights} fileTypeID={entity} src={null} srcName={elemName}
                    files={files} setFiles={(compFiles) => { setFiles(compFiles) }}
                    noUploads={true} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={"PJ"}
                    altFilesTypes={`../api/${entity}/Get${entity}FilesType`} altFilesUrl={`../api/${entity}/Get${entity}Files`}
                    altRemoveFilesUrl={`../api/${entity}/Remove${entity}File`} altUploadFilesUrl={`../api/${entity}/Upload${entity}Files`} />*/}
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {noButtons ? "" : 
                    <>{noSubmit ? "" : ((dlgLead?.idLead && !isDuplicate) ? <Button className="px-3" color="success" onClick={() => {
                        var generateModel = modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>Modifier</Button> : <Button className="px-3" color="success" onClick={() => {
                        var generateModel = modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm();
                        }
                    }}><i className="fa fa-plus"></i>Ajouter</Button>)}
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button></>
                }
            </ModalFooter>
        </Modal>
    );
}

function FlowsModal({ t, title, noScroll, idElem, dataFlows, parentContext, callback }) {

    const [flows, setFlows] = React.useState(dataFlows || []);

    React.useEffect(() => {
        //initFlows();
    }, []);

    function initFlows() {
        var args = { id: idElem };
        commonFunc.getMethod("../api/lead/GetLeadFlows", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {

                    Swal.close();


                    setFlows(response.data.result);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: "Erreur de récupération de l'historique :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: "Erreur de récupération de l'historique : No Response"
                });
            }
        });
    }

    return (
        <Modal isOpen={true} className={`modal-flows ${noScroll ? "modal-noscroll" : ""}`} size="xxl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <Historical type="modelFlows" elemId={0} hideRefresh loadExternalParent={() => { return new Promise((resolve, reject) => { resolve(flows); }); }} url={""} getRoutes={parentContext.props.getRoutes} shouldRender={true} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t("gal_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}

function PreviewModal({ title, url, successBtnCb, hideEmail, lead, parentContext, callback }) {

    //console.debug("render modal");

    return (
        <Modal isOpen={true} className="modal-report" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2">
                <PdfViewer url={url} containerId="embdActFinalPDf" shouldRender={true} style={{ minHeight: "740px" }}></PdfViewer>
            </ModalBody>
            <ModalFooter className="px-2 d-block">
                {!hideEmail && <Button className="px-3 float-start" color="primary" onClick={() => { sendEmailDialog(lead, parentContext.props.dataCfg, parentContext.props.i18nManager); }}><i className="fa fa-envelope"></i>Envoi email</Button>}
                
                <Button className="px-3 float-end" color="secondary" onClick={() => { callback(); }}>Fermer</Button>
                {successBtnCb ? <Button className="px-3 float-end" color="success" onClick={() => { successBtnCb(); }}>Marquer comme envoyé</Button> : ""}
            </ModalFooter>
        </Modal>
    );
}





//Création du schéma pour le paramètrage du formulaire
const itvModalSchema = yup.object().shape({
    fromEmail: yup.object().required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    targetsEmail: yup.array().min(1, "Veuillez renseigner un email").required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    files: yup.array(),//.required("Ce champ est obligatoire"),
    objectLabel: yup.string().required("Ce champ est obligatoire")
}).required();

function EmailModal({ title, leadId, lead, dataCfg, i18nManager, callback }) {
    React.useEffect(() => {
        //console.debug("mount");

        initEmailModal();
    }, []);

    const [froms, setFroms] = React.useState([]);
    const [contacts, setContacts] = React.useState([]);
    const [files, setFiles] = React.useState([]);
    const [objEml, setObjEml] = React.useState(null);
    const [emailStatus] = React.useState(<Col lg="10" className="alert alert-sm mb-0 wait" id="errorEmailAlert"><span className="input-icon">En Attente</span><span className="ms-3">Patientez SVP...</span></Col>);
    const [modelTemplates, setModelTemplates] = React.useState([]);
    const [template, setTemplate] = React.useState("");

    const editorRef = React.useRef(null);

    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(itvModalSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }
    
    /*const { ref: refTgtEmail, ...restTgtEmail } =*/ register("targetsEmail");
    /*const { ref: refFiles, ...restFiles } =*/ register("files", { value: [] });
    const { ref: refObjectLabel, ...restObjectLabel } = register("objectLabel");

    function initEmailModal() {
        Swal.fire({
            title: i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var argsModel = { id: lead.assignSiteID, level: 2 };
        commonFunc.getMethod("../api/site/GetSite", argsModel).then((responseSite) => {
            if (responseSite.data.isSuccess) {
                lead.extSite = responseSite.data.result;

                var argsModel = { id: -1, categ: "LEAD" };
                commonFunc.getMethod("../api/lead/GetLeadModels", argsModel).then((response) => {
                    if (response.data.isSuccess) {
                        if (response.data.result?.models) {
                            var mailModel = response.data.result?.models.filter(model => model.extID === "EML_CFG");
                            if (mailModel.length) {
                                var objEmlCurr = JSON.parse(mailModel[0].value);
                                setObjEml(objEmlCurr);

                                if (objEmlCurr?.Email?.Subject) setValue("objectLabel", objEmlCurr?.Email?.Subject);
                                if (objEmlCurr?.Email?.From) {
                                    setFroms([{ value: objEmlCurr.Email.From.Item1, label: objEmlCurr.Email.From.Item2 }, { value: lead.extSite?.email, label: lead.extSite?.name + " (" + lead.extSite?.email + ")" }]);
                                    if (objEmlCurr.SetDefaultFromSvcIDs && objEmlCurr.SetDefaultFromSvcIDs[lead.serviceID]) {
                                        var defaultEmail = objEmlCurr.SetDefaultFromSvcIDs[lead.serviceID];
                                        if (defaultEmail === objEmlCurr.Email.From.Item1) setValue("fromEmail", { email: objEmlCurr.Email.From.Item1, name: objEmlCurr.Email.From.Item2, firstName: "" });
                                        else setValue("fromEmail", { email: defaultEmail, name: defaultEmail, firstName: "" });
                                    }
                                    else setValue("fromEmail", { email: lead.extSite?.email, name: lead.extSite?.name, firstName: "" });
                                }
                                else {
                                    setValue("fromEmail", { email: lead.extSite?.email, name: lead.extSite?.name, firstName: "" });
                                }

                                var args = { id: leadId };
                                /*commonFunc.getMethod("../api/lead/GetLeadContacts", args).then((response) => {
                                    var data = response.data;
                                    if (data.isSuccess) {
                                        var defaultClient = [];
                                        if (!commonFunc.isBlank(lead.client?.email)) defaultClient.push({ email: lead.client?.email, name: lead.client?.name, firstName: lead.client?.firstName });

                                        var contacts = [...defaultClient, ...data.result];

                                        setContacts(contacts);
                                    }
                                    //else {
                                    //    Swal.fire({
                                    //        icon: "warning",
                                    //        title: "Attention",
                                    //        html: "Aucun contacts"
                                    //    });
                                    //}
                                });*/
                                var defaultClient = [];
                                if (!commonFunc.isBlank(lead.client?.email)) {
                                    defaultClient.push({ email: lead.client?.email, name: lead.client?.name, firstName: lead.client?.firstName });
                                    setValue("targetsEmail", [defaultClient[0]]);
                                }

                                var contacts = [...defaultClient, ...lead.contacts];

                                setContacts(contacts);
                                //setValue("targetsEmail", [{ email: lead.client?.email, name: lead.client?.name, firstName: lead.client?.firstName }]);

                                if (objEmlCurr?.IncludeFiles) {
                                    //Appel réseau plutôt que dépendance sur lead qui n'est pas actualisé juste après génération PDF
                                    var argsFiles = { bindID: args.id, fileId: -1 };
                                    commonFunc.getMethod("../api/lead/GetLeadFiles", argsFiles).then((response) => {//GetReportFinalFiles
                                        var data = response.data;
                                        if (data.isSuccess) {
                                            if (data.count > 0) {
                                                var filteredFiles;
                                                if (objEmlCurr.Email?.FilesTypes) filteredFiles = data.result.filter(file => objEmlCurr.Email.FilesTypes.indexOf(file.categ) >= 0);
                                                else filteredFiles = data.result;

                                                if (filteredFiles.length > 1) {
                                                    filteredFiles = filteredFiles.sort((a, b) => {
                                                        return moment(b.dSysMod).diff(a.dSysMod, "seconds");
                                                    });
                                                }

                                                setFiles(filteredFiles);
                                                if (filteredFiles.length) setValue("files", [filteredFiles[0]]);
                                            }
                                            //else {
                                            //    Swal.fire({
                                            //        icon: "warning",
                                            //        title: "Attention",
                                            //        html: "Aucun fichiers"
                                            //    });
                                            //}
                                        }
                                    });
                                    /*if (lead.leadFiles?.length > 0) {
                                        var filteredFiles;
                                        if (objEmlCurr.Email?.FilesTypes) filteredFiles = lead.leadFiles.map(file => file.file).filter(file => objEmlCurr.Email.FilesTypes.indexOf(file.categ) >= 0);
                                        else filteredFiles = lead.leadFiles.map(file => file.file);

                                        if (filteredFiles.length > 1) {
                                            filteredFiles = filteredFiles.sort((a, b) => {
                                                return moment(b.dSysMod).diff(a.dSysMod, "seconds");
                                            });
                                        }

                                        setFiles(filteredFiles);
                                        if (filteredFiles.length) setValue("files", [filteredFiles[0]]);
                                    }*/
                                }

                                /*commonFunc.getMethod("../weatherforecast/WFGetEmailStatus", null).then((response) => {
                                    if (response.data.isSuccess) {
                                        setEmailStatus(<Col lg="10" className="alert alert-sm mb-0 success alert-success" id="errorEmailAlert"><span className="input-icon">Actif</span><span className="ms-3"></span></Col>);
                                    } else {
                                        setEmailStatus(<Col lg="10" className="alert alert-sm mb-0 failure alert-danger" id="errorEmailAlert"><span className="input-icon">InActif</span><span className="ms-3">{response.data.errorMessage}</span></Col>);
                                    }
                                });*/

                                if (objEmlCurr?.Email?.ModelCateg && objEmlCurr?.Email?.ModelExtId) {
                                    //var argsModel = { filter: "lead", useParentSite: true, excludeMode: 0, categ: objEmlCurr?.Email?.ModelCateg };
                                    //commonFunc.getMethod("../api/data/GetAllModels", argsModel).then((response) => {
                                    var argsModel = { id: -1, categ: objEmlCurr?.Email?.ModelCateg };
                                    commonFunc.getMethod("../api/lead/GetLeadModels", argsModel).then((response) => {
                                        if (response.data.isSuccess && response.data.result) {
                                            //console.debug(response.data.result);
                                            var mailModel = response.data.result.models.filter(model => objEmlCurr?.Email?.ModelExtId.indexOf(model.extID) >= 0);
                                            if (mailModel.length) {
                                                setModelTemplates(mailModel);
                                                updateHtmlContent(mailModel[0]);
                                            }


                                        }/* else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Echec",
                                                html: "Echec du chargement du template l'email<br/>" + response.data.errorMessage
                                            });
                                        }*/
                                    });
                                }

                                Swal.close();

                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec du chargement de la configuration email<br/>Configuration introuvable"
                                });
                            }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec du chargement de la configuration email<br/>Aucune configuration"
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec du chargement de la configuration email<br/>" + response.data.errorMessage
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de récupération infos agences<br/>" + responseSite.data.errorMessage
                });
            }
        });
    }

    function updateHtmlContent(model, customContent) {
        var objHtml = JSON.parse(model.value);

        var htmlProc = () => {
            var content = customContent || objHtml.Details;
            var temp = document.createElement('div');
            temp.innerHTML = content;

            temp.querySelectorAll("[data-bind], [data-bindtype]").forEach((element) => {
                var valueBind;
                if (element.getAttribute("data-bindtype") === "address") {
                    valueBind = commonFunc.getValue(lead, element.getAttribute("data-bind") + ".addressMain") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".addressPlus") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".addressPlus2") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".pc") + " ";
                    valueBind += commonFunc.getValue(lead, element.getAttribute("data-bind") + ".city");
                }
                else if (element.getAttribute("data-bindtype")?.startsWith && element.getAttribute("data-bindtype").startsWith("contacts;")) {
                    valueBind = "";
                    var contacts = commonFunc.getValue(lead, element.getAttribute("data-bind"));
                    if (contacts?.length) {
                        var filteredContacts = contacts.filter(contact => contact.contactType === element.getAttribute("data-bindtype").replace("contacts;", ""));
                        if (filteredContacts.length) {
                            valueBind = commonFunc.getValue(filteredContacts[0], element.getAttribute("data-subbind")) || ""
                        }
                    }
                    if (commonFunc.isBlank(valueBind) && element.getAttribute("data-fallback")) {
                        var subObj = commonFunc.getValue(lead, element.getAttribute("data-fallback"));
                        if (subObj) valueBind = commonFunc.getValue(subObj, element.getAttribute("data-subbind")) || "";
                    }
                }
                else {
                    valueBind = commonFunc.getValue(lead, element.getAttribute("data-bind")) || "";
                }

                if (element.getAttribute("data-format") === "phone") {
                    valueBind = valueBind.replaceAll(" ", ".");
                }

                element.innerHTML = valueBind;
            });
            setTemplate("<br/>" + temp.innerHTML);
        };


        if (objHtml.ShopOrderDependence) {
            commonFunc.getMethod("../api/lead/GetLastShopOrderFromLead", { leadId: leadId }).then((response) => {
                if (response.data.isSuccess) {
                    lead.shopOrder = response.data.result;

                    htmlProc();
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de récupération de la dépendance<br/>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            htmlProc();
        }
    }

    function triggerSubmit(data) {

        Swal.fire({
            title: 'Envoi de l\'Email en cours...',
            didOpen: () => { Swal.showLoading() },
        });

        ///console.debug(data);
        var args = objEml.Email;
        args.BindID = leadId;
        args.From = { Item1: data.fromEmail.email, Item2: data.fromEmail.name + (data.fromEmail.firstName ? (" " + data.fromEmail.firstName) : "") };
        args.To = {};
        data.targetsEmail.forEach(target => { args.To[target.email] = target.name + (target.firstName ? (" " + target.firstName) : "") });
        args.Subject = data.objectLabel;
        args.Attachments = data.files;
        args.SrcObject = leadId;
        args.ModelBindID = leadId;

        args.HtmlMessage = editorRef.current ? editorRef.current.getContent() : "";
        args.PlainMessage = editorRef.current ? editorRef.current.getContent({ format: "text" }) : "";
        console.debug(args);
        commonFunc.postMethod("../api/lead/SendLeadEmail", args).then((response) => {
            if (response.data && response.data.isSuccess) {
                Swal.fire({
                    icon: "success",
                    title: i18nManager.t("gal_success"),
                    html: "Email envoyé avec succès",
                    didOpen: () => { Swal.hideLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    if (callback && typeof (callback) === "function") { callback(data); }
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de l'envoi de l'email<br/>" + response.data.errorMessage
                });
            }
        });
    }

    //console.debug("render modal");

    //console.debug(getValues());
    //console.debug(errors);

    var bindPropResult = "targetsEmail";
    //var currValue = "";
    var inputStyle = {};

    var onChange = () => { };

    var customOpt = [];
    contacts.forEach((option, index) => {
        customOpt.push({ value: option.email, label: option.name + " " + option.firstName + " (" + option.email + ")" });
    });
    /*if (getValues(bindPropResult)) currValue = getValues(bindPropResult);
    else if (customOpt.length) currValue = customOpt[0].value;*/

    var compArgs = {
        isMulti: true,
        id: "targetContactsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResult) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var contactSrc = contacts.filter(contact => contact.email === v.value);
                    if (contactSrc.length) return contactSrc[0];
                    else return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResult, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResult, e.value);
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResult) ? true : false,
        /*defaultValue: (() => {
            var arrayOptions;
            if (Array.isArray(currValue)) {
                arrayOptions = currValue;
            }
            else if (currValue && currValue.split) {
                arrayOptions = currValue.split(";");
            }
            //console.debug(currValue);
            //console.debug(arrayOptions);
            var option;
            if (arrayOptions) {
                option = arrayOptions.map((v, i) => {
                    if (!commonFunc.isBlank(v)) {
                        var value = parseInt(v) ? parseInt(v) : v;
                        var filterOption = customOpt.filter(opt => opt.value === value);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].label;
                        }
                        else {
                            label = v;
                        }
                        return { label: label, value: value };
                    }
                    else {
                        return "";
                    }
                });
            }
            else {
                var filterOption = customOpt.filter(opt => opt.value === currValue);
                var label;
                if (filterOption.length > 0) {
                    label = filterOption[0].label;
                }
                if (label) {
                    option = { label: label, value: currValue };
                }
                else {
                    option = (currValue ? currValue : "");
                }
            }
            return option;
        })(),*/
        options: customOpt,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (contacts?.length) {
        compArgs.key = "emails" + contacts?.length;
        compArgs.defaultValue = { label: customOpt[0].label, value: customOpt[0].value };
    }


    var bindPropResultF = "fromEmail";
    var fromArgs = {
        isMulti: false,
        id: "fromsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultF) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultF, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultF, { email: e.value, name: e.label });
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResultF) ? true : false,
        options: froms,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (froms?.length) {
        fromArgs.key = "froms" + froms?.length;
        var defaultFrom = froms.filter(from => from.value === getValues("fromEmail")?.email);
        if (defaultFrom?.length) fromArgs.defaultValue = { label: defaultFrom[0].label, value: defaultFrom[0].value };
        else fromArgs.defaultValue = { label: froms[0].label, value: froms[0].value };
    }


    var bindPropResultFiles = "files";
    //var currValueFiles = "";

    var customOptFiles = [];
    files.forEach((option, index) => {
        customOptFiles.push({ value: option.idFile, label: option.name + " (" + option.prefix + ")" });
    });
    /*if (customOptFiles.length) {
        if (getValues(bindPropResultFiles)) currValue = getValues(bindPropResultFiles);
        else {
            var filteredFiles = files.filter(file => file.categ === "PDF");
            if (filteredFiles.length) {
                currValueFiles = filteredFiles[0].idFile;
            }
            else currValueFiles = customOpt[0].value; 
        }
    }*/

    var selFilesArgs = {
        isMulti: true,
        id: "targetFilesEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultFiles) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var fileSrc = files.filter(contact => contact.idFile === v.value);
                    if (fileSrc.length) return fileSrc[0];
                    else return null;
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultFiles, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultFiles, e.value);
            }
        },
        invalid: commonFunc.getValue(errors, bindPropResultFiles) ? true : false,
        /*defaultValue: (() => {
            var arrayOptions;
            if (Array.isArray(currValueFiles)) {
                arrayOptions = currValueFiles;
            }
            else if (currValueFiles && currValueFiles.split) {
                arrayOptions = currValueFiles.split(";");
            }
            console.debug(currValueFiles);
            console.debug(arrayOptions);
            var option;
            if (arrayOptions) {
                option = arrayOptions.map((v, i) => {
                    if (!commonFunc.isBlank(v)) {
                        var value = parseInt(v) ? parseInt(v) : v;
                        var filterOption = customOptFiles.filter(opt => opt.value === value);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].label;
                        }
                        else {
                            label = v;
                        }
                        return { label: label, value: value };
                    }
                    else {
                        return "";
                    }
                });
            }
            else {
                var filterOption = customOptFiles.filter(opt => opt.value === currValueFiles);
                var label;
                if (filterOption.length > 0) {
                    label = filterOption[0].label;
                }
                if (label) {
                    option = { label: label, value: currValueFiles };
                }
                else {
                    option = (currValueFiles ? currValueFiles : "");
                }
            }
            return option;
        })(),*/
        options: customOptFiles,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (files?.length) {
        selFilesArgs.key = "files" + files?.length;
        selFilesArgs.defaultValue = { label: customOptFiles[0].label, value: customOptFiles[0].value };
    }

    return (
        <Modal isOpen={true} className="modal-email" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title || "Transfert de Fichiers"}</ModalHeader>
            <ModalBody className="px-2">
                <Row className="m-0 mb-3 px-1 d-none">
                    <Col className="align-content-center text-lg-end" lg="2">
                        <label className="m-0">Etat du service:</label>
                    </Col>
                    {emailStatus}
                </Row>
                <div className="mail-box">
                    <Form id="frmsendmail" action="" className="form needs-validation" method="" onSubmit={handleSubmit(triggerSubmit)}>
                        <div className="mail-body">
                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">De:</label>
                                    </Col>
                                    <Col lg="8">
                                        {froms?.length ? <Select {...fromArgs} options={froms} /> : (() => {
                                            var email = getValues("fromEmail");
                                            return email ? (email.name + " (" + email.email + ");") : "";
                                        })()}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "fromEmail") ? "d-block" : ""}`}>{errors.fromEmail ? errors.fromEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">A:</label>
                                    </Col>
                                    <Col lg="8">
                                        {<CreatableSelect {...compArgs} />/*contacts?.length ? <CreatableSelect {...compArgs} /> : (() => {
                                            var emails = getValues("targetsEmail");
                                            return emails?.map(option => option.name + "(" + option.email + ");");
                                        })()*/}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "targetsEmail") ? "d-block" : ""}`}>{errors.targetsEmail ? errors.targetsEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">Objet:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Input id="targetSubject" name="Objet" placeholder="Objet" type="text" autoComplete="off" aria-autocomplete="none"
                                            innerRef={refObjectLabel} {...restObjectLabel}
                                            invalid={errors.objectLabel ? true : false} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "objectLabel") ? "d-block" : ""}`}>{errors.objectLabel ? errors.objectLabel.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {objEml?.IncludeFiles ? <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Fichiers:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Select {...selFilesArgs} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "files") ? "d-block" : ""}`}>{errors.files ? errors.files.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup> : ""}

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Type de message:</label>
                                    </Col>
                                    <Col lg="6">
                                        <Input id={"selectMsgType"} style={inputStyle} type="select" onChange={(e) => {
                                            var model = modelTemplates.filter(model => model.idModel === parseInt(e.target.value));
                                            if (model.length) {
                                                updateHtmlContent(model[0]);
                                            }
                                        }}>
                                            {modelTemplates.map((option, index) => <option key={index} value={option.idModel}>
                                                {option.title}
                                            </option>)}
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>

                        </div>
                        <Editor
                            onInit={(evt, editor) => editorRef.current = editor}
                            initialValue={template}
                            init={{
                                language: "fr_FR",
                                valid_elements: '*[*]',
                                valid_children: "+body[style]",
                                height: 410,
                                menubar: false,
                                //readonly: true, >> cf disabled
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'help', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | fontsize | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat',
                                content_style: `body { font-family:Helvetica,Arial,sans-serif; font-size:14px} 
                                #mtnfr {font-family:Nunito} 
                                .sepline { border: 1px dashed red; }
                                .displayNone { display: none }
                                .d-none { display: none }`
                            }}
                        />
                        <button type="button" id="btnSaveEmailSig" className="btn btn-sm btn-simple btn-dark btn-ok mt-3 d-none"><i className="fa fa-pencil-alt"></i>&nbsp;Définir signature</button>
                    </Form>
                </div>

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="primary" form="frmsendmail"><i className="fa fa-reply"></i>Envoyer</Button>
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}>Fermer</Button>
            </ModalFooter>
        </Modal>
    );
}


function CardProject(props) {
    var { lead, context, altT, templatesWidgetList } = props;


    const [collapsed, setCollapsed] = React.useState(true);
    const [selectedPerson, setSelectedPerson] = React.useState(lead.persons[0]);
    const [selectedVersion, setSelectedVersion] = React.useState(lead.persons[0].versions.length);

    /*const statusHistory = [
                                        { status: "nouveau", date: "2024-06-20T10:00:00", note: "Premier contact établi" },
                                        { status: "en_cours", date: "2024-06-22T14:30:00", note: "Analyse des besoins" },
                                        { status: "tarifs_envoyes", date: "2024-06-25T16:45:00", note: "Devis envoyé par email" }
                                    ];
            
                                    const customStatusConfig = {
                                        nouveau: {
                                            label: "Nouveau",
                                            icon: "fa fa-user",
                                            color: "primary",
                                            bgColor: "#007bff",
                                            textColor: "#0056b3"
                                        }
                                        // ... autres statuts personnalisés
                                    };*/

    var currentVersion;
    var currentVersionFiltered = selectedPerson?.versions?.filter(version => version.recall === selectedVersion);
    if (currentVersionFiltered.length) currentVersion = currentVersionFiltered[0];

    const statusHistory = currentVersion?.flows;

    var statusOrder = [3001, 3002, 3003, 3004, 3097, 3005, 3006];


    var customStatusConfig = {};
    context.state.status?.forEach(status => {
        //if (status.idStatus !== 3003 && (status.idStatus !== 3004 && status.idStatus !== 3007)) {
            customStatusConfig[status.idStatus] = status;
        //}

        var statusObj = status;
        if (!statusObj.bgColor && statusObj.css) {
            switch (true) {
                case statusObj.css.indexOf("purple-300") >= 0:
                    statusObj.bgColor = "#BA68c8";
                    break;
                case statusObj.css.indexOf("amber-600") >= 0:
                    statusObj.bgColor = "#ffb300";
                    break;
                case statusObj.css.indexOf("cyan-600") >= 0:
                    statusObj.bgColor = "#00acc1";
                    break;
                case statusObj.css.indexOf("green-400") >= 0:
                    statusObj.bgColor = "#66bb6a";
                    break;


                case statusObj.css.indexOf("bg-danger") >= 0:
                    statusObj.bgColor = "#DC3545";
                    break;
                case statusObj.css.indexOf("bg-success") >= 0:
                    statusObj.bgColor = "#198754";
                    break;
                case statusObj.css.indexOf("bg-primary") >= 0:
                    statusObj.bgColor = "#0D6EFD";
                    break;
                case statusObj.css.indexOf("bg-secondary") >= 0:
                    statusObj.bgColor = "#6C757D";
                    break;
                case statusObj.css.indexOf("bg-info") >= 0:
                    statusObj.bgColor = "#0DCAF0";
                    break;
                case statusObj.css.indexOf("bg-warning") >= 0:
                    statusObj.bgColor = "#FFC107";
                    break;
                default:
                    break;
            }
        }
        //if (!statusObj.textColor) statusObj.textColor = "#000000";
        if (!statusObj.textColor) statusObj.textColor = statusObj.bgColor;


        var classFa = "";
        if (statusObj.css?.indexOf("fa-")) {
            statusObj.css.split(" ").forEach((classElem) => {
                //console.debug(classElem.startsWith("fa-") + classElem);
                classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
            });
            if (classFa) statusObj.icon = "fa " + classFa;
        }
    });
    /*if (customStatusConfig[3004] && lead.extras) {
        var visitExtras = lead.extras.map(ext => {
            if (ext.name === "visiteDate") return commonFunc.formatDateTime(commonFunc.restStringToDate(ext.value), true);
            if (ext.name === "visitItv") return ext.value;
            return null;
        }).filter(ext => ext !== null);
        customStatusConfig[3004 + "tooltip"] = { title: "Visite", value: visitExtras };
    }
    if (customStatusConfig[3006] && lead.extras) {
        var lossExtras = lead.extras.filter(ext => ext.name === "lossReason");
        if (lossExtras.length) {
            customStatusConfig[3006 + "tooltip"] = { title: "Perdu", value: lossExtras[0].value };
        }
    }*/

    var alertDesign = (status) => {
        switch (status) {
            case 3004: return "warning";
            case 3005: return "success";
            case 3006: return "danger";
            default:
                return ""
        }
    };

    var tabBadge = (version, personContainer) => {
        switch (version.statusID) {
            //case 3006: return <Badge color="danger">Annulée</Badge>;
            //case 3097: return <Badge color="secondary">Archivée</Badge>;
            default:
                //if (personContainer.versions.length === version.recall) return <Badge color="primary">Actuelle</Badge>;
                return ""
        }
    };


    var saveCb = () => {
        //context.loadLead(leadResponse.result.idLead);
        context.getLeads(3000, true, () => {
            //showDtSelID("tableLeads", data.result.idLead);
        });
    };

    var filesAltObj = {};
    if (context.filesType) filesAltObj.filesType = context.filesType;
    else filesAltObj.altFilesTypes = "../api/lead/GetLeadFilesType";

    filesAltObj.files = currentVersion?.leadFiles?.map(file => file.file.categ !== "RCP" ? file.file : null).filter(file => file !== null) || [];


    var notifDate = lead.dSysNotif ? commonFunc.restStringToDate(lead.dSysNotif) : null;

    console.debug(customStatusConfig);

    var supStyle = {};
    //var leftColor = customStatusConfig[lead.statusID]?.bgColor || "#6C757D";
    //if (leftColor) supStyle.borderLeft = "3px solid " + leftColor;
    return <Card key={lead.idLead} className={`card-project card-${lead.idLead} ${collapsed ? "collapsed" : ""}`} style={lead.priority > 0 ? { backgroundColor: "rgba(255, 0, 24, 0.05)", ...supStyle } : { ...supStyle }}>
        <CardHeader>
            <Row>
                <Col className="col-auto me-3 pe-0 align-content-center collapse-trigger" onClick={() => { setCollapsed(!collapsed) }}>{(collapsed ? <i className="fa fa-chevron-right float-end me-2 mt-1" style={{ width: "10px" }}></i> : <i className="fa fa-chevron-down float-end me-2 mt-1" style={{ width: "10px" }}></i>)}</Col>
                <Col className="col-auto me-3 pe-0 align-content-center"><Badge className="py-2" color="dark">{lead.extRef}</Badge></Col>
                <Col>
                    <h5 className="fw-bold mb-0">{lead.title}</h5>
                    <span className="text-secondary me-2">{lead.description}</span><span className="text-secondary">{" Signature : " + moment(lead.startDate).format("DD MMM YYYY")}</span>

                    {(lead.dSysNotif !== lead.dSysCreat && commonFunc.isValidDate(notifDate) && notifDate.getFullYear() > 1970) ? <Badge className="" color="warning"><i className="fa fa-clock me-2"></i>{`Rappel le ${commonFunc.formatDateTime(moment(notifDate).utc(true).toDate())}`}</Badge> : ""}
                </Col>
                <Col className="col-12 col-sm-auto align-items-end text-end align-content-center">
                    <Badge color="warning">{lead.category.name}</Badge>
                </Col>
                <Col className="col-12 col-sm-auto align-items-end text-end">
                    {lead.persons.map(person => {
                        return <Badge key={"iconNav" + person.idLead} className="p-2" color={person.groupID <= 2 ? "primary" : "success"} style={{ width: "35px", height: "35px", alignContent: "center" }}>{(person.client.firstName.charAt(0) + person.client.name.charAt(0)).toUpperCase()}</Badge>;
                    })}
                    <div className="text-secondary" style={{ fontSize: "12px" }}>Dernière activité : {moment(lead.dSysMod).format("DD/MM/YYYY")}</div>
                </Col>
            </Row>
        </CardHeader>
        <CardBody className={`p-0 ${collapsed ? "d-none" : ""}`}>
            <div className="d-flex">
                <div className="p-3" style={{ width: "300px", borderRight: "1px solid #0000002d" }}>
                    {(() => {
                        var lastGroupID;
                        return lead.persons.map(person => {
                            var supGroup = lastGroupID !== person.groupID ? <div className="text-secondary fw-bold mb-2" style={{ fontSize: "12px" }}>{person.group.title.toUpperCase()}</div> : "";
                            lastGroupID = person.groupID;
                            return <div key={"navContainer" + person.idLead}>
                                {supGroup}
                                <Card className={`card-person ${selectedPerson.idLead === person.idLead ? "card-selected" : ""}`}>
                                    <CardBody className="p-2">
                                        <Row className="m-0 align-items-center" onClick={() => { setSelectedPerson(person); setSelectedVersion(person.versions.length); }}>
                                            <Col className="col-auto p-0"><Badge className="p-2" color={person.groupID <= 2 ? "primary" : "success"} style={{ width: "35px", height: "35px", alignContent: "center" }}>{(person.client.firstName.charAt(0) + person.client.name.charAt(0)).toUpperCase()}</Badge></Col>
                                            <Col className="col-auto p-2">
                                                <div className="fw-bold">{person.client.firstName + " " + person.client.name}</div>
                                                <div className="text-secondary">{person.group.title} &bull; V{person.recall}</div>
                                            </Col>
                                            {(person.versions[person.versions.length - 1].status.step === 3 || person.versions[person.versions.length - 1].status.step === 4) && <Col className="p-0" style={{ justifyItems: "end" }}><div className={`rounded bg-${alertDesign(person.versions[person.versions.length - 1].statusID)}`} style={{ width: "8px", height: "8px" }}></div></Col>}
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>;
                        });
                    })()}
                    <Card><CardBody className="text-secondary">+ Ajouter une partie</CardBody></Card>
                </div>



                {selectedPerson?.client && <div className="p-3" style={{ flex: "1 0" }}>
                    <div>
                        <Row className="m-0 align-items-center">
                            <Col className="col-auto p-0"><Badge className="p-2" color={selectedPerson.groupID <= 2 ? "primary" : "success"} style={{ width: "35px", height: "35px", alignContent: "center" }}>{(selectedPerson.client.firstName.charAt(0) + selectedPerson.client.name.charAt(0)).toUpperCase()}</Badge></Col>
                            <Col className="col-auto p-2">
                                <div className="fw-bold">{selectedPerson.client.firstName + " " + selectedPerson.client.name}</div>
                                <div className="text-secondary">{selectedPerson.client.email} &bull; {selectedPerson.client.tel}</div>
                            </Col>
                            <Col className="p-0" style={{ justifyItems: "end", textAlign: "end" }}>
                                {context.props.checkRights("LEAD", "A") ? <>
                                    <Button href={`mailto:${selectedPerson.client.email}`} className="btn-simple btn-icon d-none" size="sm" color="dark"><i className="fa fa-envelope me-2"></i></Button>
                                    <Button className="btn-simple btn-icon" size="sm" color="dark" disabled={lead.statusID >= 3004} onClick={() => { sendEmailDialog(lead, context.props.dataCfg, context.props.i18nManager); }}><i className="fa fa-envelope me-2"></i></Button>

                                    <Button href={`callto:${selectedPerson.client.tel}`} className="btn-simple btn-icon" size="sm" color="primary"><i className="fa fa-phone me-2"></i></Button>

                                    <Button className="btn-simple btn-icon d-none" size="sm" color="info"><i className="fa fa-comment me-2"></i></Button>
                                </> : ""}
                            </Col>
                        </Row>
                    </div>

                    <hr className="hr-line-solid" />

                    <Card className="text-center">
                        <CardHeader>
                            <Nav tabs>
                                {selectedPerson.versions.map(version => <NavItem key={`nav${version.idLead}`}><NavLink className={`${selectedVersion === version.recall ? "active" : ""}`} onClick={() => { setSelectedVersion(version.recall); }}>{`V${version.recall}`} {tabBadge(version, selectedPerson)}</NavLink></NavItem>)}
                            </Nav>
                        </CardHeader>
                        <CardBody>
                            {selectedPerson.versions?.length && selectedVersion ? (selectedPerson.versions.filter(version => version.recall === selectedVersion).map(version => {

                                var flowArchiveFiltered = version.flows.filter(flow => flow.statutID === 3097);
                                var flowArchive = flowArchiveFiltered.length ? flowArchiveFiltered[0] : null;

                                return <div key={`versionContainer-${version.idLead}`} className=" text-start">
                                    {flowArchive && <Alert className="text-dark" color="secondary"><i className="fa fa-archive me-2"></i>Archivé le {moment(flowArchive.dSysMod).format("DD MMM YYYY")} - {flowArchive.name}</Alert>}

                                    <div className="text-secondary fw-bold" style={{ fontSize: "12px" }}>{("Avancement").toUpperCase()}</div>
                                    <WidgetBreadcrumb
                                        srcTag={version.idLead}
                                        srcData={version}
                                        currentStatus={version.statusID}
                                        statusHistory={statusHistory}
                                        statusOrder={statusOrder}
                                        statusConfig={customStatusConfig}
                                        showDates={true}
                                        showTooltips={true}
                                        variant="horizontal" // ou "vertical"
                                        size="sm" // "sm", "md", ou "lg"
                                        altCreateStatus={[3001]}
                                        lastStatus={[3097, 3005, 3006]}
                                        //allowLastRender={true}
                                    />

                                    <Row className="m-0">
                                        {(version.status.step === 3 || version.status.step === 4) && <Alert color={`${alertDesign(version.statusID)}`}>TODO</Alert>}
                                    </Row>

                                    <Row>
                                        {context.props.checkRights("LEAD_FILES", "L") ? <Col xs="12">
                                            <div className="text-secondary fw-bold" style={{ fontSize: "12px" }}>{("Documents").toUpperCase()}</div>
                                            <FilesCustom className={"lead-files" + version.idLead} bindID={version.idLead} rightType={"LEAD_FILES"} checkRights={context.props.checkRights} fileTypeID="LEAD" src={version}
                                                waitForCompletion={(fileUpReq) => { return fileUpReq.ftype === "DVS"; }} srcName={version.title} withFilters noUploadBtn
                                                shouldRender altRendering noRemove defaultFileType={"DVS"} {...filesAltObj}
                                                altFilesUrl="../api/lead/GetLeadFiles" altRemoveFilesUrl="../api/lead/RemoveLeadFile" altUploadFilesUrl="../api/lead/UploadLeadFiles" />
                                        </Col> : ""}
                                    </Row>
                                    <Row className="m-0">
                                        {context.props.checkRights("LEAD", "S") ? <Card className={`my-3 p-3 col-12 lead-${lead.statusID}`} style={{ backgroundColor: "#1B57710E", color: "#014051" }}>
                                            <div className="p-2"><i className="fa fa-plus me-2"></i>Prochaines actions</div>
                                            <div>
                                                TODO Changement de statuts
                                            </div>
                                            <div><Button className="" color="secondary" size="sm" onClick={() => { context.generateLeadRecap(lead) }}><i className="fa fa-file-pdf"></i> Générer un récap.</Button></div>
                                        </Card> : ""}
                                    </Row>

                                    {context.props.checkRights("LEAD", "U") && <Button className="btn-simple d-none2" size="sm" color="info" onClick={() => showDialogLead(altT(templatesWidgetList[0].name), templatesWidgetList[0].tag, lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}><i className="fa fa-edit me-2"></i>Modifier</Button>}
                                    {context.props.checkRights("LEAD", "CU") && <Button className="btn-simple d-none2" size="sm" color="success" onClick={() => showDialogLead(altT(templatesWidgetList[0].name.replace("edit", "duplicate")), templatesWidgetList[0].tag, lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager, true)}><i className="fa fa-copy me-2"></i>Dupliquer</Button>}


                                    {context.props.checkRights("LEAD", "R") && <Button className="btn-simple" size="sm" color="secondary" onClick={() => { dialogAltLead(context.props.i18nManager.t("lead.tabDetails"), "DLG_LEAD", lead, context.leadModels, saveLead, saveCb, context.modalGenManager, context.props, context.props.i18nManager) }}><i className="fa fa-circle-info me-2"></i>Consulter</Button>}

                                    {context.props.checkRights("LEAD_FLOWS", "L") && <Button className="btn-simple" size="sm" color="warning" onClick={() => { context.showFlows(lead.idLead, lead); }}><i className="fa fa-clock-rotate-left me-2"></i>Historique</Button>}


                                </div>})) : ""}
                        </CardBody>
                    </Card>
                </div>}
            </div>
        </CardBody>
    </Card>;
}



const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageLeads));